import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Segmented,
  Progress,
  Space,
  Typography,
  Tag,
  Tooltip,
  Select,
  Input,
  Switch,
  Avatar,
  Form,
  Checkbox,
  Dropdown,
  Menu,
  Pagination,
  Spin,
  Skeleton,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  EyeFilled,
  EyeInvisibleFilled,
  MoreOutlined,
  LockOutlined,
  MailOutlined,
  KeyOutlined,
  DownloadOutlined,
  UploadOutlined,
  PlusOutlined,
  VideoCameraOutlined,
  StarOutlined,
  StarFilled,
  AudioOutlined,
  LineChartOutlined,
  PlayCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  CalendarOutlined,
  CheckCircleFilled,
  DownOutlined,
  RightOutlined,
  PauseCircleOutlined,
} from "@ant-design/icons";
import { TbSend } from "react-icons/tb";
import {
  PhysicianPageWrapper,
  CustomButton,
  CustomSecondaryButton,
  CustomTitle,
  CustomSubTitle,
  CustomFilterSelection,
  StyledMenu,
  CustomFilterSelectionForMyVideoPage,
} from "./styled";
import Scrollbar from "react-scrollbars-custom";
import recordingService from "../../../services/recording";
import scriptService from "../../../services/script";
import AudioRecorder from "../../record/Audio";
import SaveRecordingModel from "./component/SaveRecordingModel";
import UploadRecordingModal from "./component/UploadRecordingModal";
import FileSelectionModal from "./component/FileSelectionModal";
import AudioPlayerModal from "./component/AudioPlayerModal";
import moment from "moment";
import AddPhysicianFormModal from "./component/AddPhysicianFormModal";
import { StyledTable } from "../admin/videos/styled";
import { notify, debounce } from "../../../utils/helper";
import {
  physicianService,
  patientService,
  assistantService,
} from "../../../services/user";
import DeleteConfirmationModal from "./component/DeleteConfirmationModal";
import PhysicianDetailModal from "./component/PhysicianDetailModal";
import { capitalizeFirstLetter, titleFormat } from "../../../utils/utils";
import videoService from "../../../services/videos";
import { extractToken } from "../../../utils/localStorage";
import AddPatientModal from "../patients_page/AddPatientModal";
import VideoContainer from "../videos_container/VideoContainer";
import VideosPlayer from "../videos_container/VideosPlayer";
import ModelWrapper from "../../modal/ModelWrapper";
import script from "../../../services/script";
import ViewScriptDetails from "../admin/scripts/ViewScriptDetails";
import VideoPreviewModal from "../admin/videos/VideoPreviewModal";
import {
  CustomSearchContainer,
  CustomExpandSearchContainer,
} from "../../table-item";
import Filter from "../../table-item/filter/Filter";
import { FiSearch, FiEdit } from "react-icons/fi";
import { apiGet } from "../../../utils/axios";
import { domainUrl } from "../../../utils/domainUrls";
import mailSchedular from "../../../services/mailSchedular";
import AddAssistantModal from "./component/AddAssistantModal";
import { globalRoles } from "../../../utils/roles";
import TermAndCondition from "../../record/TermAndCondition";
import { IoClose, IoCheckmarkSharp } from "react-icons/io5";
import authService from "../../../services/auth";
import ScheduleEmailModal from "./component/ScheduleEmailModal";
import RescheduleModal from "./component/RescheduleModal";
import PatientDetailModal from "./component/PatientDetailModal";
import { ExpandedTableWrapper } from "../admin/scripts/RecordingByScript";
import AssisgnedVideoModal from "../admin/videos/AssisgnedVideoModal";
import { useLocation, useHistory } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const RevisedModal = React.memo(
  ({
    isOpen,
    onClose,
    pendingAction,
    loading,
    onSubmit,
    reviewedScriptData,
    consentData,
  }) => {
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);

    const handleSubmit = (value) => {
      onSubmit(value);
    };

    const handleCancel = () => {
      onClose();
    };

    return (
      <ModelWrapper
        title={
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Revised Script
            </h3>
            <p className="font-14 text-secondry mb-0">
              Please enter a revised script content.
            </p>
          </div>
        }
        footer={null}
        show={isOpen}
        setShow={onClose}
        width={750}
        keyClose={false}
        className="custom-detail-modal"
      >
        <Form
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            scriptContent: reviewedScriptData?.description1 || "",
          }}
        >
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Form.Item
                name="scriptContent"
                label="Script Content"
                rules={[
                  { required: true, message: "Please enter a script content" },
                ]}
              >
                <Input.TextArea
                  rows={12}
                  placeholder="Enter script content"
                  autoSize={{ minRows: 7 }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <div
                style={{
                  padding: "5px",
                  // background: "var(--border-color)",
                  // border: "1px solid #fff8db",
                  borderRadius: "5px",
                }}
              >
                <div
                  className="row-flex text-primary"
                  style={{ fontSize: "13px" }}
                >
                  <div className="mr-5" style={{ padding: "5px 0" }}>
                    <Checkbox
                      checked={isTermsAccepted}
                      onChange={(e) => {
                        setIsTermsAccepted(e.target.checked);
                      }}
                    />
                  </div>
                  <div style={{ padding: "5px 0" }}>
                    I have reviewed the script named{" "}
                    <strong>
                      {reviewedScriptData?.scriptTitle || "[Script Title]"}
                    </strong>{" "}
                    and confirm that the clinical information presented is
                    accurate, appropriate for educational purposes, and aligns
                    with current medical standards and best practices in the
                    field of{" "}
                    <strong>{consentData?.specialty || "[Specialty]"}</strong>.
                    I approve this script for production and distribution as
                    part of the Meducate AI educational library.
                  </div>
                </div>
              </div>
            </Col>
            <Col span={24} className="d-flex justify-end gap-12">
              <CustomSecondaryButton
                onClick={handleCancel}
                disabled={loading}
                size="large"
              >
                Cancel
              </CustomSecondaryButton>
              <CustomButton
                htmlType="submit"
                loading={loading}
                disabled={loading || !isTermsAccepted}
                size="large"
                style={{
                  backgroundColor: "#52c41a",
                  borderColor: "#52c41a",
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </CustomButton>
            </Col>
          </Row>
        </Form>
      </ModelWrapper>
    );
  }
);

const CommentModal = React.memo(
  ({
    isOpen,
    onClose,
    pendingAction,
    loading,
    onSubmit,
    consentData,
    scriptData,
  }) => {
    const [internalComment, setInternalComment] = useState("");
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);

    useEffect(() => {
      if (isOpen) {
        setInternalComment("");
        setIsTermsAccepted(false);
      }
    }, [isOpen]);

    const handleSubmit = () => {
      if (!internalComment.trim()) {
        notify("error", "Please enter a comment");
        return;
      }
      onSubmit(internalComment.trim());
    };

    const handleCancel = () => {
      setInternalComment("");
      onClose();
    };

    return (
      <ModelWrapper
        title={
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              {pendingAction?.status === "approved"
                ? "Approve Script"
                : "Reject Script"}
            </h3>
            <p className="font-14 text-secondry mb-0">
              Please add a comment for this action
            </p>
          </div>
        }
        footer={null}
        show={isOpen}
        setShow={onClose}
        width={750}
        keyClose={false}
        className="custom-detail-modal"
      >
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <div
              className="font-medium mb-12"
              style={{ color: "var(--primary-text-color)" }}
            >
              Comment <span style={{ color: "#ff4d4f" }}>*</span>
            </div>
            <Input.TextArea
              rows={4}
              placeholder={`Enter your ${
                pendingAction?.status === "approved" ? "approval" : "rejection"
              } comment...`}
              value={internalComment}
              onChange={(e) => setInternalComment(e.target.value)}
              disabled={loading}
              maxLength={500}
              showCount
              autoFocus
            />
          </Col>
          {pendingAction?.status === "approved" && (
            <Col span={24}>
              <div
                style={{
                  padding: "5px",
                  // background: "var(--border-color)",
                  // border: "1px solid #fff8db",
                  borderRadius: "5px",
                }}
              >
                {/* <div className="font-semibold text-primary">Script Approval Statement :</div> */}
                <div
                  className="row-flex text-primary"
                  style={{ fontSize: "13px" }}
                >
                  <div className="mr-5" style={{ padding: "5px 0" }}>
                    <Checkbox
                      checked={isTermsAccepted}
                      onChange={(e) => {
                        setIsTermsAccepted(e.target.checked);
                      }}
                    />
                  </div>
                  <div style={{ padding: "5px 0" }}>
                    I have reviewed the script named{" "}
                    <strong>
                      {scriptData?.scriptTitle || "[Script Title]"}
                    </strong>{" "}
                    and confirm that the clinical information presented is
                    accurate, appropriate for educational purposes, and aligns
                    with current medical standards and best practices in the
                    field of{" "}
                    <strong>{consentData?.specialty || "[Specialty]"}</strong>.
                    I approve this script for production and distribution as
                    part of the Meducate AI educational library.
                  </div>
                </div>
              </div>
            </Col>
          )}

          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton
              onClick={handleCancel}
              disabled={loading}
              size="large"
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton
              onClick={handleSubmit}
              loading={loading}
              disabled={
                !internalComment.trim() ||
                (pendingAction?.status === "approved" && !isTermsAccepted)
              }
              size="large"
              style={{
                backgroundColor:
                  pendingAction?.status === "approved" ? "#52c41a" : "#ff4d4f",
                borderColor:
                  pendingAction?.status === "approved" ? "#52c41a" : "#ff4d4f",
              }}
            >
              {loading
                ? "Processing..."
                : pendingAction?.status === "approved"
                ? "Approve"
                : "Reject"}
            </CustomButton>
          </Col>
        </Row>
      </ModelWrapper>
    );
  }
);

const PhysicianPage = () => {
  const user = extractToken();
  const isPhysician =
    user?.role === "Physician" || user?.role === globalRoles.OWNER;
  const isAssignedPhysician = user?.role === globalRoles.ASSISTANT;
  const isAssistant = user?.role === "Assistant";
  const isSuperAdmin = user?.role === "SuperAdmin";
  const isOwner = user?.role === globalRoles.OWNER;
  const isLibraryManager = user?.role === globalRoles.LIBRARY_MANAGER;

  const location = useLocation();
  const history = useHistory();

  // Helper to get tab from URL
  function getTabFromUrl() {
    const params = new URLSearchParams(location.search);
    return params.get("tab");
  }

  // Compute initial tab from URL or fallback to default logic
  const getInitialTab = () => {
    const urlTab = getTabFromUrl();
    if (urlTab) return urlTab;
    if (isAssistant) return "My Videos";
    if (isLibraryManager) return "Voice Recording";
    return "Dashboard";
  };

  const [selectedTab, setSelectedTab] = useState(getInitialTab());
  const [isOpen, setIsOpen] = useState(false);
  const [recordingOpen, setRecordingOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [physicians, setPhysicians] = useState([]);
  const [patients, setPatients] = useState([]);
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recordingFileName, setRecordingFileName] = useState("");

  const [recordingData, setRecordingData] = useState([]);
  const [recordingFileUrl, setRecordingFileUrl] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isPhysicianEdit, setIsPhysicianEdit] = useState(false);
  const [physicianId, setPhysicianId] = useState(null);
  const [isDeatilsOpen, setIsDeatilsOpen] = useState(false);
  const [selectedPhysicianId, setSelectedPhysicianId] = useState(null);
  const [physicianDataById, setPhysicianDataById] = useState([]);
  const [count, setCount] = useState(0);
  const [allScript, setAllScript] = useState([]);
  const [scriptStatus, setScriptStatus] = useState("");
  const [selectedScriptId, setSelectedScriptId] = useState(null);
  const [scriptIdForViewDetail, setScriptIdForViewDetail] = useState(null);
  const [scriptDataById, setScriptDataById] = useState([]);
  const [scriptDetailModalOpen, setScriptDetailModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [filterTab, setFilterTab] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [specialtyList, setSpecialtyList] = useState(null);
  const [sortingColumn, setSortingColumn] = useState("");
  const [allPhysicians, setAllPhysicians] = useState([]);
  const [isConsentAccept, setIsConsentAccept] = useState("");
  const [consentModalOpen, setConsentModalOpen] = useState(false);
  const [reviewedModalOpen, setReviewedModalOpen] = useState(false);
  const [reviewedScriptData, setReviewedScriptData] = useState([]);
  const [consentData, setConsentData] = useState([]);
  const [scriptData, setScriptData] = useState([]);
  const [scriptFilterTab, setScriptFilterTab] = useState([]);
  const [scriptSortColumn, setScriptSortColumn] = useState("");
  const [recordingId, setRecordingId] = useState(null);
  const [schedulerPagination, setSchedulerPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [schedulerDataCount, setSchedulerDataCount] = useState(0);

  const [isPersonalizeModalOpen, setIsPersonalizeModalOpen] = useState(false);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [currentVideoForPersonalize, setCurrentVideoForPersonalize] =
    useState(null);
  const [isPatientCreationModalOpen, setIsPatientCreationModalOpen] =
    useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [videos, setVideos] = useState([]);

  const [scripts, setScripts] = useState([]);
  const [scriptsLoading, setScriptsLoading] = useState(false);
  const [selectedScript, setSelectedScript] = useState(null);
  const [selectedScriptDetails, setSelectedScriptDetails] = useState(null);

  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [selectedPatientForSchedule, setSelectedPatientForSchedule] = useState(
    []
  );
  const [selectedVideoForSchedule, setSelectedVideoForSchedule] = useState([]);
  const [scheduleDate, setScheduleDate] = useState(null);

  const [scheduledMails, setScheduledMails] = useState([]);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);
  const [isPatientDetailModalOpen, setIsPatientDetailModalOpen] =
    useState(false);

  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [selectedMailForReschedule, setSelectedMailForReschedule] =
    useState(null);
  const [newScheduleDate, setNewScheduleDate] = useState(null);

  const [isAssistantModalOpen, setIsAssistantModalOpen] = useState(false);
  const [allAssistants, setAllAssistants] = useState([]);
  const [selectedAssistantId, setSelectedAssistantId] = useState(null);
  const [isAssistantEdit, setIsAssistantEdit] = useState(false);
  const [patientSelectedId, setPatientSelectedId] = useState(null);
  const [patientCount, setPatientCount] = useState(0);
  const [patientEdit, setPatientEdit] = useState(false);
  const [patientId, setPatientId] = useState([]);

  const [scheduleFrequency, setScheduleFrequency] = useState(undefined);
  const [repeatUntil, setRepeatUntil] = useState(null);

  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [actionComment, setActionComment] = useState("");
  const [pendingAction, setPendingAction] = useState(null);

  const [enableFrequency, setEnableFrequency] = useState(false);
  const [customFrequencyNumber, setCustomFrequencyNumber] = useState(1);
  const [isCustomFrequency, setIsCustomFrequency] = useState(false);

  const [isMfaEnabled, setIsMfaEnabled] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const [recordingSearchText, setRecordingSearchText] = useState("");
  const [recordingStatusFilter, setRecordingStatusFilter] = useState("");
  const [filteredRecordingData, setFilteredRecordingData] = useState([]);
  const [recordingPagination, setRecordingPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [recordingDataCount, setRecordingDataCount] = useState(0);
  const audioRef = useRef(null);

  const pageSize = 10;

  const [selectedPhysicianIds, setSelectedPhysicianIds] = useState([]);
  const [selectedAssistantIds, setSelectedAssistantIds] = useState([]);

  const [patientEditable, setPatientEditable] = useState(false);
  const [videoPagination, setVideoPagination] = useState({
    pageSize: 25,
    current: 1,
    total: 0,
  });
  const [videoSearchText, setVideoSearchText] = useState("");
  const [schedulerSearchText, setSchedulerSearchText] = useState("");
  const [videoFilterTab, setVideoFilterTab] = useState([]);
  const [videoSpecialtyList, setVideoSpecialtyList] = useState([]);
  const [patientSearchText, setPatientSearchText] = useState("");
  const [videoTypeFilter, setVideoTypeFilter] = useState([]);
  const [selectedAssistantData, setSelectedAssistantData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [search, setSearch] = useState("");
  const [isVideoPreviewModalVisible, setIsVideoPreviewModalVisible] =
    useState(false);
  const [selectedVideoForPreview, setSelectedVideoForPreview] = useState(null);
  const [expandedRecordingPanels, setExpandedRecordingPanels] = useState([]);
  const [isRecordingDeleteModalOpen, setIsRecordingDeleteModalOpen] =
    useState(false);
  const [selectedRecordingId, setSelectedRecordingId] = useState([]);
  const [recordingSelectedRowKeys, setRecordingSelectedRowKeys] = useState([]);
  const [isUploadRecordingModalOpen, setIsUploadRecordingModalOpen] =
    useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [isFileSelectionModalOpen, setIsFileSelectionModalOpen] =
    useState(false);
  const [
    selectedRecordingForFileSelection,
    setSelectedRecordingForFileSelection,
  ] = useState(null);
  const [fileSelectionAction, setFileSelectionAction] = useState("download");

  const [isAudioPlayerModalOpen, setIsAudioPlayerModalOpen] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState(null);

  const [notificationType, setNotificationType] = useState("both");
  const [videoTypeSorting, setVideoTypeSorting] = useState("asc");
  const [videoSortOrderByTitle, setVideoSortOrderByTitle] = useState("");

  // Add state for physician detail modal
  const [physicianDetailModal, setPhysicianDetailModal] = useState(false);
  const [physicianData, setPhysicianData] = useState([]);

  // Add new state for infinite scroll in My Videos
  const [allVideos, setAllVideos] = useState([]);
  const [myVideosCurrentPage, setMyVideosCurrentPage] = useState(1);
  const [myVideosHasMore, setMyVideosHasMore] = useState(true);
  const [myVideosLoadMoreLoading, setMyVideosLoadMoreLoading] = useState(false);
  const [schedulerColumn, setSchedulerColumn] = useState("");
  const myVideosPageSize = 9;
  const getScheduledMailList = async () => {
    try {
      const res = await mailSchedular.getScheduledMailList();
      const mailsData = res?.data?.results;
      if (Array.isArray(mailsData)) {
        setScheduledMails(mailsData);
      } else {
        setScheduledMails([]);
        console.warn("Scheduled mails data is not an array:", mailsData);
      }
    } catch (error) {
      console.error("Error fetching scheduled mails:", error);
      setScheduledMails([]);
    }
  };

  const cancelScheduledMail = async (mailId) => {
    try {
      setIsLoading(true);
      await mailSchedular.cancelScheduleMail(mailId);
      notify("success", "Scheduled email cancelled successfully!");

      getScheduledMailList();
    } catch (error) {
      console.error("Error cancelling scheduled mail:", error);
      notify("error", "Failed to cancel scheduled email");
    } finally {
      setIsLoading(false);
    }
  };

  const rescheduleScheduledMail = async () => {
    if (!selectedMailForReschedule || !newScheduleDate) {
      notify("error", "Please select a new date and time");
      return;
    }

    try {
      setIsLoading(true);
      await mailSchedular.rescheduleMail(selectedMailForReschedule.id, {
        newDate: newScheduleDate.toISOString(),
      });

      notify("success", "Email rescheduled successfully!");

      setScheduledMails((prevMails) =>
        prevMails.map((mail) =>
          mail.id === selectedMailForReschedule.id
            ? { ...mail, scheduledTime: newScheduleDate.toISOString() }
            : mail
        )
      );

      setIsRescheduleModalOpen(false);
      setSelectedMailForReschedule(null);
      setNewScheduleDate(null);

      getScheduledMailList();
    } catch (error) {
      console.error("Error rescheduling mail:", error);
      notify("error", "Failed to reschedule email");
    } finally {
      setIsLoading(false);
    }
  };

  const hasScheduledMails = (patientId) => {
    if (!Array.isArray(scheduledMails) || scheduledMails.length === 0) {
      return false;
    }
    return scheduledMails.some((mail) => mail?.patientId === patientId);
  };

  const fetchPatients = async (searchInput = patientSearchText) => {
    try {
      setLoading(true);
      const response = await patientService.getAll(
        pagination?.pageSize,
        pagination?.current,
        searchInput,
        "",
        "true",
        ""
      );
      // console.log("patient data", response?.data?.results);
      const processedData = response?.data?.results?.map((item) => ({
        ...item,
        name: capitalizeFirstLetter(item.name),
        statusValue: item.status,
        isScheduled: false,
        key: item.id,
      }));
      setPatients(processedData || []);
      setPatientCount(response?.data?.totalResults);
    } catch (error) {
      console.error("Error fetching patients:", error);
    } finally {
      setLoading(false);
    }
  };

  const schedulePatientEmail = useCallback(async () => {
    if (
      !selectedPatientForSchedule ||
      !selectedVideoForSchedule ||
      !scheduleDate ||
      !notificationType
    ) {
      notify(
        "error",
        "Please select patient, video, schedule date and notification type"
      );
      return;
    }

    if (scheduleFrequency && !repeatUntil) {
      notify("error", "Please select repeat until date for frequency");
      return;
    }

    setIsLoading(true);
    try {
      const videoUrlsArray = Array.isArray(selectedVideoForSchedule)
        ? selectedVideoForSchedule
        : [selectedVideoForSchedule];

      const patientIdsArray = Array.isArray(selectedPatientForSchedule)
        ? selectedPatientForSchedule
        : [selectedPatientForSchedule];

      const payload = {
        patientIds: patientIdsArray,
        videoUrls: videoUrlsArray,
        scheduleDate: scheduleDate.toISOString(),
        deliveryType: notificationType,
      };

      if (scheduleFrequency && repeatUntil) {
        payload.frequency = scheduleFrequency;
        payload.repeatUntil = repeatUntil.toISOString();
        if (scheduleFrequency === "custom") {
          payload.customDays = customFrequencyNumber;
        }
      }

      const res = await mailSchedular.sendEmailToPatient(payload);

      notify("success", "Email scheduled successfully");

      setIsScheduleModalOpen(false);
      setSelectedPatientForSchedule([]);
      setSelectedVideoForSchedule([]);
      setScheduleDate(null);
      setScheduleFrequency(null);
      setRepeatUntil(null);
      setIsCustomFrequency(false);
      setCustomFrequencyNumber(1);
      setPatientEditable(false);
      getScheduledMailList();
      fetchPatients();
    } catch (error) {
      console.error("Error scheduling email:", error);
      notify("error", "Failed to schedule email");
    } finally {
      setIsLoading(false);
    }
  }, [
    selectedPatientForSchedule,
    selectedVideoForSchedule,
    scheduleDate,
    scheduleFrequency,
    repeatUntil,
    customFrequencyNumber,
    getScheduledMailList,
    fetchPatients,
  ]);

  const handleCommentSubmit = useCallback(
    async (comment) => {
      try {
        setLoading(true);
        if (pendingAction.status === "revised") {
          const res = await script.scriptApproveOrReject(
            pendingAction.scriptId,
            {
              status: pendingAction.status,
              scriptContent: comment?.scriptContent,
            }
          );
          notify(
            "success",
            `Script ${capitalizeFirstLetter(
              res?.data?.script?.status
            )} Successfully.`
          );
        } else {
          const res = await script.scriptApproveOrReject(
            pendingAction.scriptId,
            {
              status: pendingAction.status,
              comment: comment,
            }
          );
          notify(
            "success",
            `Script ${capitalizeFirstLetter(
              res?.data?.script?.status
            )} Successfully.`
          );
        }

        setIsCommentModalOpen(false);
        setReviewedModalOpen(false);
        setPendingAction(null);

        fetchScript();
      } catch (error) {
        notify("error", "Failed to process script action");
      } finally {
        setLoading(false);
      }
    },
    [pendingAction]
  );

  const handleCommentClose = useCallback(() => {
    setIsCommentModalOpen(false);
    setPendingAction(null);
  }, []);

  // Refactor getAllVideos for infinite scroll
  const getAllVideos = async (
    page = 1,
    searchInput = videoSearchText,
    isLoadMore = false
  ) => {
    try {
      if (isLoadMore) {
        setMyVideosLoadMoreLoading(true);
      } else {
        setIsLoading(true);
      }
      const response = await videoService.getVideos(
        myVideosPageSize,
        page,
        sortingColumn,
        searchInput,
        JSON.stringify(videoFilterTab),
        videoTypeFilter,
        "",
        "asc",
        videoSortOrderByTitle
      );
      const newVideos = response?.data?.videos?.results || [];
      if (isLoadMore) {
        setAllVideos((prev) => [...prev, ...newVideos]);
        setVideos(response?.data?.videos); // for compatibility if needed
      } else {
        setAllVideos(newVideos);
        setVideos(response?.data?.videos);
      }
      setMyVideosHasMore(newVideos.length === myVideosPageSize);
      setMyVideosCurrentPage(page);
    } catch (error) {
    } finally {
      if (isLoadMore) {
        setMyVideosLoadMoreLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  const getAllScripts = async (page = 1) => {
    setScriptsLoading(true);
    try {
      const response = await scriptService.getMyScript();
      setScripts(response?.data || []);
    } catch (error) {
      notify("error", "Failed to load scripts");
    } finally {
      setScriptsLoading(false);
    }
  };

  const getScriptById = async (id) => {
    try {
      const response = await scriptService.getScript(id);
      return response?.data;
    } catch (error) {
      notify("error", "Failed to load script details");
      return null;
    }
  };

  const getStatusTag = (status) => {
    return (
      <Tag color={status ? "green" : "red"}>
        {status ? "Active" : "Inactive"}
      </Tag>
    );
  };

  const fetchPhysicians = async (searchInput = searchText) => {
    try {
      setLoading(true);
      const response = await physicianService.getAll(
        pagination?.pageSize,
        pagination?.current,
        searchInput,
        sortingColumn,
        JSON.stringify(filterTab)
      );
      // console.log("physicians:", response?.data);
      const processedData = processData(response?.data?.results || []);
      setPhysicians(processedData);
      setCount(response?.data?.totalResults);
    } catch (error) {
      console.error("Error fetching physicians:", error);
    } finally {
      setLoading(false);
    }
  };

  const getMyProfile = async () => {
    try {
      setLoading(true);
      const res = await physicianService.getMyProfile();
      setIsConsentAccept(res?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchAudioFiles = async (searchInput = recordingSearchText) => {
    try {
      setLoading(true);
      const res = await recordingService.getMyVoiceRecording(
        recordingPagination?.pageSize,
        recordingPagination?.current,
        searchInput,
        recordingStatusFilter
      );
      setRecordingData(res?.data?.recordings?.results);
      setRecordingDataCount(res?.data?.recording?.totalResults);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const assignRecording = async (id) => {
    try {
      setLoading(true);
      const res = await recordingService.assignRecording({
        recordingId: [id],
      });
      fetchAudioFiles();
      notify("success", "Recording successfully send to the Library Manager.");
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getRecordingFileFromS3 = async (fileName) => {
    try {
      const res = await recordingService.getRecordingFileFromS3({ fileName });
      setRecordingFileUrl(res?.data?.fileUrl);
      setRecordingFileName(fileName);
    } catch (err) {}
  };

  const processData = (data) => {
    return data.map((item) => ({
      ...item,
      name: (
        <div className="row-flex">
          <div
            className="d-flex justify-content-center"
            style={{ position: "relative" }}
          >
            <Avatar
              size={40}
              style={{
                marginRight: "12px",
                backgroundColor: "var(--border-color)",
                color: "var(--primary-text-color)",
              }}
            >
              {capitalizeFirstLetter(item?.name?.[0])}
            </Avatar>
            {item.isEmailVerified && (
              <CheckCircleFilled
                style={{
                  position: "absolute",
                  top: "-2px",
                  right: "8px",
                  color: "#52c41a",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  fontSize: "16px",
                }}
              />
            )}
          </div>
          <div
            className="d-flex flex-column justify-start align-start"
            style={{ gap: "0px" }}
          >
            <span>
              {capitalizeFirstLetter(item.name)}{" "}
              <span className="ml-5">
                {" "}
                {item?.boardMember && (
                  <Tooltip title="Board Member">
                    <span>
                      <Tag className="cursor board-member-tag">BM</Tag>
                    </span>
                  </Tooltip>
                )}
              </span>
            </span>
            <span>{capitalizeFirstLetter(item?.email)}</span>
          </div>
        </div>
      ),
      statusValue: item.status,
      specialtyName: titleFormat(item.specialty) || "Not specified",
      key: item.id,
    }));
  };

  const handlePhysicianCheckbox = (checked, record) => {
    if (checked) {
      setSelectedPhysicianIds([...selectedPhysicianIds, record.id]);
      setSelectedAssistantIds([]);
      setIsDropdownVisible(true);
    } else {
      const newSelection = selectedPhysicianIds.filter(
        (id) => id !== record.id
      );
      setSelectedPhysicianIds(newSelection);
      setIsDropdownVisible(newSelection.length > 0); // Close dropdown if no items selected
    }
  };

  const handleAssistantCheckbox = (checked, record) => {
    if (checked) {
      setSelectedAssistantIds([...selectedAssistantIds, record._id]);
      setSelectedPhysicianIds([]);
      setIsDropdownVisible(true);
    } else {
      const newSelection = selectedAssistantIds.filter(
        (id) => id !== record._id
      );
      setSelectedAssistantIds(newSelection);
      setIsDropdownVisible(newSelection.length > 0);
    }
  };

  const get2FATag = (is2FaDisable) => {
    if (is2FaDisable) {
      return <Tag color="red">Disabled</Tag>;
    }
    return <Tag color="green">Enabled</Tag>;
  };

  const physicianColumns = [
    {
      title: "Select",
      key: "select",
      width: 60,
      fixed: "left",
      render: (_, record) => (
        <Checkbox
          checked={selectedPhysicianIds.includes(record.id)}
          onChange={(e) => handlePhysicianCheckbox(e.target.checked, record)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "fullName",
      width: 250,
      sorter: (a, b) => (a.fullName || "").localeCompare(b.fullName || ""),
    },
    {
      title: "Specialty",
      dataIndex: "specialty",
      key: "specialty",
      align: "center",
      sorter: (a, b) => (a.specialty || "").localeCompare(b.specialty || ""),
      // filters: Object.entries(specialtyMap).map(([value, text]) => ({
      //   text,
      //   value,
      // })),
      // onFilter: (value, record) => record.specialty === value,
      render: (_, record) => record.specialtyName,
    },

    {
      title: "Consent Form",
      dataIndex: "consentAccept",
      align: "center",
      key: "consentAccept",
      width: 100,
      render: (_, consentAccept) => (
        <Tooltip
          title={consentAccept?.consentAccept ? "Accepted" : "Not Accepted"}
        >
          {consentAccept?.consentAccept ? (
            <EyeFilled
              className="cursor"
              style={{ color: "#8a3ef4" }}
              onClick={() => {
                setConsentData(consentAccept);
                setConsentModalOpen(true);
              }}
            />
          ) : (
            <EyeInvisibleFilled
              className="cursor"
              style={{ color: "#a9a9a9" }}
            />
          )}
        </Tooltip>
      ),
      hidden: user?.role !== "SuperAdmin",
    },
    {
      title: "2FA Status",
      dataIndex: "is2FaDisable",
      key: "2faStatus",
      width: 120,
      align: "center",
      render: (is2FaDisable) => get2FATag(is2FaDisable),
    },
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      align: "center",
      key: "isEmailVerifiedText",
      sorter: (a, b) =>
        (a.isEmailVerifiedText || "").localeCompare(
          b.isEmailVerifiedText || ""
        ),
      // filters: [
      //   { text: "Verified", value: true },
      //   { text: "Not Verified", value: false },
      // ],
      // onFilter: (value, record) => record.isEmailVerified === value,
      render: (verified) => (
        <Tag color={verified ? "green" : "orange"}>
          {verified ? "Verified" : "Not Verified"}
        </Tag>
      ),
    },
    // {
    // title: "Group Name",
    //   dataIndex: "groupName",
    //   key: "groupName",
    //   width: 200,
    //   sorter: (a, b) => {
    //     const aGroup = a.groupName || "N/A";
    //     const bGroup = b.groupName || "N/A";
    //     return aGroup.localeCompare(bGroup);
    //   },
    //   render: (groupName, record) => (
    //     <span style={{ color: 'var(--primary-text-color)' }}>
    //       {groupName || record.company || "N/A"}
    //     </span>
    //   ),
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      width: 200,
      key: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <div
              onClick={() => {
                setPhysicianId(record?.id);
                setIsDeatilsOpen(true);
              }}
              className="icon-button-view"
            >
              <EyeOutlined />
            </div>
          </Tooltip>
          {user?.role === globalRoles.SUPERADMIN && (
            <>
              <Tooltip title="Edit">
                <div
                  onClick={() => {
                    setIsPhysicianEdit(true);
                    setSelectedPhysicianId(record?.id);
                    setIsOpen(true);
                  }}
                  className="icon-button-edit"
                >
                  <EditOutlined />
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={() => {
                    setSelectedId(record?.id);
                    setIsDeleteModalOpen(true);
                  }}
                  className="icon-button-delete"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </>
          )}
        </Space>
      ),
    },
  ];

  const patientColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 350,
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (name, record) => (
        <div className="row-flex">
          <div className="d-flex justify-content-center">
            <Avatar
              size={40}
              style={{
                marginRight: "8px",
                backgroundColor: "var(--border-color)",
                color: "var(--primary-text-color)",
              }}
            >
              {capitalizeFirstLetter(name?.[0])}
            </Avatar>
          </div>
          <div className="row-flex flex-column">
            <div className="" style={{ gap: "8px" }}>
              <span style={{ marginRight: "8px" }}>{name}</span>
              {hasScheduledMails(record.id) && (
                <Tooltip title="Has Scheduled Emails">
                  <CalendarOutlined
                    style={{ color: "#52c41a", fontSize: "14px" }}
                  />
                </Tooltip>
              )}
            </div>
            {record.mobile?.number && (
              <div>
                <span>
                  {record.mobile.countryCode}{" "}
                  {record.mobile.number.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    "($1) $2-$3"
                  )}
                </span>
              </div>
            )}
            <div>
              <span>{record.email}</span>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Assigned Physicians",
      dataIndex: "physician",
      align: "center",
      width: 150,
      key: "physician",
      render: (_, record) => {
        const physicians = Array.isArray(record.physician)
          ? record.physician
          : [];

        if (physicians.length === 0) {
          return <Tag>N/A</Tag>;
        }

        const names = physicians.map((p) => p.name);

        return (
          <div
            className="cursor"
            onClick={() => {
              setPhysicianData(physicians);
              setPhysicianDetailModal(true);
            }}
          >
            <Avatar.Group
              maxCount={3}
              maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
            >
              {names.map((name, index) => (
                <Avatar
                  key={index}
                  style={{
                    backgroundColor: "var(--border-color)",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {capitalizeFirstLetter(name?.[0]) || "?"}
                </Avatar>
              ))}
            </Avatar.Group>
          </div>
        );
      },
      hidden: isPhysician || isAssignedPhysician,
    },
    // {
    //   title: "Email Verified",
    //   dataIndex: "isEmailVerified",
    //   key: "isEmailVerified",
    //   align: "center",
    //   filters: [
    //     { text: "Verified", value: true },
    //     { text: "Not Verified", value: false },
    //   ],
    //   onFilter: (value, record) => record.isEmailVerified === value,
    //   render: (verified) => (
    //     <Tag color={verified ? "green" : "orange"}>
    //       {verified ? "Verified" : "Not Verified"}
    //     </Tag>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => getStatusTag(status),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      width: 180,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      align: "center",
      key: "updatedAt",
      width: 180,
      sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Schedule Email">
            <div
              onClick={() => {
                setSelectedPatientForSchedule(record.id);
                setIsScheduleModalOpen(true);
              }}
              className="icon-button-schedule"
            >
              <CalendarOutlined />
            </div>
          </Tooltip>
          <Tooltip title="View Details">
            <div
              onClick={() => {
                setSelectedPatientDetails(record);
                setIsPatientDetailModalOpen(true);
              }}
              className="icon-button-view"
            >
              <EyeOutlined />
            </div>
          </Tooltip>

          <>
            <Tooltip title="Edit">
              <div
                onClick={() => {
                  setPatientEdit(true);
                  setPatientId(record);
                  setIsPatientCreationModalOpen(true);
                }}
                className="icon-button-edit"
              >
                <EditOutlined />
              </div>
            </Tooltip>

            <Tooltip title="Delete">
              <div
                onClick={() => {
                  setPatientSelectedId(record?.id);
                  setIsDeleteModalOpen(true);
                }}
                className="icon-button-delete"
              >
                <DeleteOutlined />
              </div>
            </Tooltip>
          </>
        </Space>
      ),
    },
  ];

  const scriptColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "scriptTitle",
      width: 250,
      sorter: (a, b) =>
        (a.scriptTitle || "").localeCompare(b.scriptTitle || ""),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      key: "status",
      //   width: "15%",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      render: (status) => {
        let color = "default";
        const lowerCaseStatus = status?.toLowerCase();
        if (lowerCaseStatus === "draft") {
          color = "gray";
        } else if (lowerCaseStatus === "pending") {
          color = "orange";
        } else if (lowerCaseStatus === "approved") {
          color = "green";
        } else if (lowerCaseStatus === "rejected") {
          color = "red";
        }
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      //   width: "15%",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      align: "center",
      key: "updatedAt",
      //   width: "15%",
      sorter: (a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt),
    },
    {
      title: "Actions",
      align: "center",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          {record?.status !== "Approved" && record?.status !== "Rejected" ? (
            <>
              <Tooltip title="Revised">
                <div
                  onClick={() => {
                    setReviewedScriptData(record);
                    handleScriptAction(record?.id, "revised");
                  }}
                  style={{
                    backgroundColor: "var(--border-color)",
                    color: "var(--primary-text-color)",
                  }}
                  className="cursor script-status-icon"
                >
                  <FiEdit />
                </div>
              </Tooltip>
              <Tooltip title="Reject">
                <div
                  onClick={() => handleScriptAction(record?.id, "rejected")}
                  style={{ backgroundColor: "#e91d26", color: "#fff" }}
                  className="cursor script-status-icon"
                >
                  <IoClose />
                </div>
              </Tooltip>
              <Tooltip title="Approve">
                <div
                  onClick={() => {
                    setScriptData(record);
                    handleScriptAction(record?.id, "approved");
                  }}
                  style={{ backgroundColor: "#46b648", color: "#fff" }}
                  className="cursor script-status-icon"
                >
                  <IoCheckmarkSharp />
                </div>
              </Tooltip>
            </>
          ) : (
            "-"
          )}
        </Space>
      ),
    },
  ];

  const myAssistantsColumns = [
    {
      title: "Select",
      key: "select",
      width: 60,
      fixed: "left",
      render: (_, record) => (
        <Checkbox
          checked={selectedAssistantIds.includes(record._id)}
          onChange={(e) => handleAssistantCheckbox(e.target.checked, record)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "fullname",
      width: 200,
      sorter: (a, b) => (a.fullname || "").localeCompare(b.fullname || ""),
    },
    {
      title: "Physician",
      dataIndex: "parent",
      width: 200,
      key: "parentName",
      sorter: (a, b) => (a.parentName || "").localeCompare(b.parentName || ""),
      render: (parent) => (
        <>
          {parent ? (
            <div className="row-flex">
              <div className="d-flex justify-content-center">
                <Avatar
                  size={40}
                  style={{
                    marginRight: "8px",
                    backgroundColor: "var(--border-color)",
                    color: "var(--primary-text-color)",
                  }}
                >
                  {capitalizeFirstLetter(parent?.name?.[0])}
                </Avatar>
              </div>
              <div className="d-flex flex-column justify-start align-start">
                <span>{capitalizeFirstLetter(parent.name)}</span>
                <span>{capitalizeFirstLetter(parent.email)}</span>
              </div>
            </div>
          ) : (
            <div>{"N/A"}</div>
          )}
        </>
      ),
      hidden: user?.role !== "SuperAdmin",
    },
    {
      title: "2FA Status",
      dataIndex: "is2FaDisable",
      key: "towfaStatus",
      width: 120,
      align: "center",
      sorter: (a, b) =>
        (a.towfaStatus || "").localeCompare(b.towfaStatus || ""),
      render: (is2FaDisable) => get2FATag(is2FaDisable),
    },
    {
      title: "Email Verified",
      dataIndex: "isEmailVerified",
      align: "center",
      key: "EmailVerified",
      sorter: (a, b) =>
        (a.EmailVerified || "").localeCompare(b.EmailVerified || ""),
      render: (verified) => (
        <Tag color={verified ? "green" : "orange"}>
          {verified ? "Verified" : "Not Verified"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      //   width: "15%",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Actions",
      align: "center",
      key: "actions",
      render: (record) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <div
              onClick={() => {
                setSelectedAssistantData(record);
                setIsDeatilsOpen(true);
              }}
              className="icon-button-view"
            >
              <EyeOutlined />
            </div>
          </Tooltip>
          <Tooltip title="Edit">
            <div
              onClick={() => {
                setIsAssistantEdit(true);
                setSelectedAssistantId(record?._id);
                setIsAssistantModalOpen(true);
              }}
              className="icon-button-edit"
            >
              <EditOutlined />
            </div>
          </Tooltip>
          {(user?.role === globalRoles.SUPERADMIN ||
            user?.role === globalRoles.PHYSICIAN ||
            user?.role === globalRoles.OWNER) && (
            <Tooltip title="Delete">
              <div
                onClick={() => {
                  setSelectedAssistantId(record?._id);
                  setIsDeleteModalOpen(true);
                }}
                className="icon-button-delete"
              >
                <DeleteOutlined />
              </div>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const expandedColumns = [
    {
      title: "Name",
      dataIndex: "videoName",
      key: "videoName",
      width: 250,
      ellipsis: true,
      render: (_, name) => (
        <div className="d-flex align-items-center justify-start gap-12">
          <div
            className="d-flex justify-content-center"
            style={{
              backgroundColor: "#f0f2ff",
              borderRadius: "6px",
              padding: "6px",
              minWidth: "32px",
              height: "32px",
            }}
          >
            <VideoCameraOutlined
              style={{
                fontSize: "14px",
                color: "#8A3EF4",
              }}
            />
          </div>
          <div className="d-flex justify-content-center" style={{ gap: "4px" }}>
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => handleVideoPreview(name)}
            >
              {capitalizeFirstLetter(name?.metadata?.videoName)}
            </span>
            {name?.isWatch && (
              <span
                style={{
                  backgroundColor: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  color: "#389e0d",
                  padding: "0px 6px",
                  borderRadius: "15px",
                  fontSize: "11px",
                }}
              >
                Watched
              </span>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      align: "center",
      width: 200,
      key: "frequency",
      render: (_, data) =>
        data?.frequency === "custom"
          ? `${data?.customDays} Days`
          : capitalizeFirstLetter(data?.frequency) || "N/A",
    },
    {
      title: "Notification Type",
      dataIndex: "delivery",
      align: "center",
      width: 200,
      key: "notificationType",
      render: (_, data) => {
        const delivery = data?.delivery;
        if (!delivery) return "-";

        const emailEnabled = delivery?.email?.enabled;
        const smsEnabled = delivery?.sms?.enabled;

        if (emailEnabled && smsEnabled) {
          return (
            <div
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              className="d-flex justify-content-center"
            >
              <Tag color="blue">Email</Tag>
              <Tag color="green">SMS</Tag>
            </div>
          );
        } else if (emailEnabled) {
          return <Tag color="blue">Email</Tag>;
        } else if (smsEnabled) {
          return <Tag color="green">SMS</Tag>;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Watched At",
      dataIndex: "isWatch",
      align: "center",
      key: "isWatch",
      render: (_, verified) =>
        verified.isWatch
          ? moment(verified.watchTimestamp).format("DD MMM YYYY hh:mm A")
          : "-",
    },
    {
      title: "Scheduled",
      dataIndex: "scheduledTime",
      key: "scheduledTime",
      // width: 120,
      align: "center",
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      //   width: "15%",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
    },
  ];

  const recordingColumns = [
    {
      title: "Recording Title",
      dataIndex: "name",
      key: "name",
      width: 250,
      ellipsis: true,
      render: (name, record) => (
        <div className="d-flex align-items-center justify-start gap-8">
          <span>{name}</span>
          {record?.clonedFiles && (
            <Tag color="green" style={{ fontSize: "10px", marginLeft: "10px" }}>
              Cloned
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Recording",
      dataIndex: "recording",
      key: "recording",
      align: "center",
      width: 250,
      render: (_, record) => (
        <>
          <div className="d-flex justify-content-center gap-12 mb-5">
            <Tooltip title="Download Recording">
              <Button
                type="text"
                size="small"
                icon={<DownloadOutlined />}
                onClick={() => {
                  // Check if recording has cloned files
                  if (record?.clonedFiles) {
                    handleFileSelection("download", record);
                  } else {
                    saveRecording(record?.recording);
                  }
                }}
                style={{ color: "var(--primary-text-color)" }}
              >
                Download
              </Button>
            </Tooltip>

            <Button
              type="default"
              size="small"
              style={{ color: "var(--primary-text-color)" }}
              icon={
                !recordingFileUrl && recordingFileName !== record?.recording && (
                  <PlayCircleOutlined />
                )
              }
              onClick={() => {
                // Check if recording has cloned files
                if ((recordingFileUrl && recordingFileName === record?.recording) && audioRef.current) {
                  audioRef.current.pause();
                  setRecordingFileUrl("");
                  setRecordingFileName("");
                  return;
                }
                if (record?.clonedFiles) {
                  handleFileSelection("play", record);
                } else {
                  getRecordingFileFromS3(record?.recording);
                }
              }}
            >
              {recordingFileUrl && recordingFileName === record?.recording
                ? "Stop"
                : "Play"}
            </Button>
          </div>
          <div>
            {recordingFileUrl && recordingFileName === record?.recording && (
              <audio
                controls
                autoPlay
                ref={audioRef}
                src={recordingFileUrl}
                onEnded={() => {
                  setRecordingFileUrl("");
                  setRecordingFileName("");
                }}
                style={{ maxWidth: "200px" }}
              />
            )}
          </div>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 150,
      ellipsis: true,
      render: (status) => {
        let color = "default";
        const lowerCaseStatus = status?.toLowerCase();
        if (lowerCaseStatus === "draft") {
          color = "gray";
        } else if (lowerCaseStatus === "pending") {
          color = "orange";
        } else if (lowerCaseStatus === "approved") {
          color = "green";
        } else if (lowerCaseStatus === "rejected") {
          color = "red";
        }
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Recorded By",
      dataIndex: "physicianName",
      key: "physicianName",
      align: "center",
      width: 200,
      ellipsis: true,
      render: (_, record) =>
        record?.user ? <div>{record?.user?.name}</div> : "-",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      align: "center",
      key: "createdAt",
      width: 200,
      ellipsis: true,
      render: (date) =>
        date ? moment(date).format("DD MMM YYYY hh:mm A") : "N/A",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 200,
      render: (_, record) => (
        <Space size="small">
          {record?.status === "approved" && (
            <Tooltip title="Upload New Recording">
              <Button
                type="text"
                size="small"
                onClick={() => {
                  setSelectedRecordingId(record.id);
                  setIsUploadRecordingModalOpen(true);
                }}
                style={{
                  padding: "0 19px",
                  borderRadius: "8px",
                  border: "1px solid #8A3EF4",
                  backgroundColor: "transparent",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  overflow: "hidden",
                  position: "relative",
                  minWidth: "40px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <UploadOutlined
                  style={{ color: "#8A3EF4", fontSize: "16px" }}
                />
              </Button>
            </Tooltip>
          )}

          {record?.status !== "approved" && record?.status !== "rejected" ? (
            <>
              <Tooltip title="Approve Recording">
                <Button
                  type="text"
                  size="small"
                  onClick={() => handleApproveOrReject(record.id, "approved")}
                  disabled={record.status === "approved"}
                  className={`approve-btn approve-btn-${record.id}`}
                  style={{
                    padding: "0 19px",
                    borderRadius: "8px",
                    border: "1px solid #46b648",
                    backgroundColor: "transparent",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    overflow: "hidden",
                    position: "relative",
                    minWidth: "40px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CheckOutlined
                    className="font-17 approve-icon"
                    style={{
                      color: "#46b648",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      fontSize: "16px",
                    }}
                  />
                  <span
                    className="approve-text"
                    style={{
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                      opacity: 0,
                      whiteSpace: "nowrap",
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#46b648",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      pointerEvents: "none",
                    }}
                  >
                    Approve
                  </span>
                </Button>
              </Tooltip>
              <Tooltip title="Reject Recording">
                <Button
                  type="danger"
                  size="small"
                  onClick={() => handleApproveOrReject(record.id, "rejected")}
                  disabled={record.status === "rejected"}
                  className={`reject-btn reject-btn-${record.id}`}
                  style={{
                    padding: "0 19px",
                    borderRadius: "8px",
                    border: "1px solid #e91d26",
                    backgroundColor: "transparent",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    overflow: "hidden",
                    position: "relative",
                    minWidth: "40px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CloseOutlined
                    className="font-17 reject-icon"
                    style={{
                      color: "#e91d26",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      fontSize: "16px",
                    }}
                  />
                  <span
                    className="reject-text"
                    style={{
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                      opacity: 0,
                      whiteSpace: "nowrap",
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#e91d26",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      pointerEvents: "none",
                    }}
                  >
                    Reject
                  </span>
                </Button>
              </Tooltip>
            </>
          ) : (
            (recordingSelectedRowKeys.length === 0 ||
              !recordingSelectedRowKeys.includes(record.id)) &&
            ""
          )}
        </Space>
      ),
    },
  ];

  const handleApproveOrReject = async (recordingId, status) => {
    try {
      setLoading(true);
      const res = await recordingService.recordingApproveOrReject(recordingId, {
        status: status,
      });
      notify(
        "success",
        `Recording ${capitalizeFirstLetter(
          res?.data?.recording?.status
        )}  Successfully.`
      );
      fetchAudioFiles();
      setLoading(false);
    } catch (error) {
      console.error("Error approving recording:", error);
    }
  };

  const saveRecording = async (fileName) => {
    const res = await recordingService.getRecordingFileFromS3({ fileName });
    const fileUrl = res?.data?.fileUrl;

    if (!fileUrl) return;
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = "recording.mp4"; // It's really WebM format
    a.click();
  };

  const handleFileSelection = (action, recording) => {
    setFileSelectionAction(action);
    setSelectedRecordingForFileSelection(recording);
    setIsFileSelectionModalOpen(true);
  };

  const handleFileSelectionCancel = () => {
    setIsFileSelectionModalOpen(false);
    setSelectedRecordingForFileSelection(null);
    setFileSelectionAction("download");
    setRecordingFileUrl("");
    setRecordingFileName("");
  };

  const handleFileSelectionConfirm = async (fileType, fileData) => {
    setIsFileSelectionModalOpen(false);

    if (fileSelectionAction === "play") {
      setSelectedFileType(fileType);

      // Get the audio URL for the selected file
      let fileName;
      if (fileType === "original") {
        fileName = selectedRecordingForFileSelection.recording;
      } else if (fileType === "cloned") {
        fileName = selectedRecordingForFileSelection.clonedFiles.fileUrl;
      }

      if (fileName) {
        await getRecordingFileFromS3(fileName);
      }

      setIsAudioPlayerModalOpen(true);
    }
  };

  const handleAudioPlayerCancel = () => {
    setIsAudioPlayerModalOpen(false);
    setSelectedFileType(null);
    setSelectedRecordingForFileSelection(null);
    setRecordingFileUrl("");
    setRecordingFileName("");
  };

  const fetchAllAssistants = async (searchInput = schedulerSearchText) => {
    try {
      setLoading(true);
      const res = await assistantService.getAll(
        schedulerPagination?.pageSize,
        schedulerPagination?.current,
        searchInput,
        schedulerColumn
      );
      const processedData = assistantProcessData(res?.data?.results || []);
      setAllAssistants(processedData);
      setSchedulerDataCount(res?.data?.totalResults);
      setLoading(false);
    } catch (error) {}
  };

  const assistantProcessData = (data) => {
    return data.map((item) => ({
      ...item,
      key: item._id, 
      name2: item?.name,
      name: (
        <>
          <div className="row-flex">
            <div className="d-flex justify-content-center">
              <Avatar
                size={40}
                style={{
                  marginRight: "8px",
                  backgroundColor: "var(--border-color)",
                  color: "var(--primary-text-color)",
                }}
              >
                {capitalizeFirstLetter(item?.name?.[0])}
              </Avatar>
            </div>
            <div className="d-flex flex-column justify-start align-start">
              <span>{capitalizeFirstLetter(item?.name)}</span>
              <span>{capitalizeFirstLetter(item?.email)}</span>
            </div>
          </div>
        </>
      ),
    }));
  };

  const handleDeleteAssistant = async () => {
    try {
      setLoading(true);
      const res = await assistantService.delete(selectedAssistantId);
      notify("success", "Scheduler deleted successfully");
      setIsDeleteModalOpen(false);
      fetchAllAssistants();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleScriptAction = (scriptId, status) => {
    setPendingAction({ scriptId, status });
    if (status === "revised") {
      setReviewedModalOpen(true);
    } else {
      setIsCommentModalOpen(true);
    }
  };

  const fetchScript = async (searchInput = searchText) => {
    try {
      setLoading(true);
      const res = await script.getScripts(
        pagination?.pageSize,
        pagination?.current,
        searchInput,
        scriptSortColumn,
        scriptFilterTab
      );
      const processedData = scriptprocessData(res?.data?.results || []);
      setAllScript(processedData);
      setCount(res?.data?.totalResults);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const scriptprocessData = (data) => {
    return data.map((item) => ({
      ...item,
      title: (
        <div
          onClick={() => {
            setScriptIdForViewDetail(item?.id);
            setScriptDetailModalOpen(true);
          }}
          style={{ width: "250px" }}
          className="cursor ellipsis"
        >
          {capitalizeFirstLetter(item.scriptTitle)}
        </div>
      ),
      description1: capitalizeFirstLetter(item.scriptContent),
      description: (
        <div style={{ width: "250px" }} className="cursor ellipsis">
          {capitalizeFirstLetter(item.scriptContent)},
        </div>
      ),
      status: capitalizeFirstLetter(item.status),
      createdAt: moment(item?.createdAt).format("DD-MMM-YYYY hh:mm A"),
      updatedAt:
        moment(item?.updatedAt).format("DD-MMM-YYYY hh:mm A") || item.createdAt,
      key: item.id,
    }));
  };

  const scriptApproveOrReject = async (id, payload) => {
    try {
      setLoading(true);
      const res = await script.scriptApproveOrReject(id, payload);
      setSelectedScriptId(null);
      setScriptStatus("");
      notify(
        "success",
        `Script ${capitalizeFirstLetter(
          res?.data?.script?.status
        )} Successfully.`
      );
      fetchScript();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchScriptById = async () => {
    try {
      setLoading(true);
      const res = await script.getScript(scriptIdForViewDetail);
      setScriptDataById(res?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getPhysicianById = async () => {
    try {
      const res = await physicianService.getById(physicianId);
      setPhysicianDataById(res?.data);
    } catch (err) {}
  };

  const handleDeleteRecording = (id) => {
    if (!isSuperAdmin || user?.role !== globalRoles.LIBRARY_MANAGER) {
      setRecordingId(id);
    }
    setIsRecordingDeleteModalOpen(true);
  };

  const confirmDeleteRecording = async () => {
    try {
      setLoading(true);
      const res = await recordingService.deleteRecording({
        ids:
          isSuperAdmin || user?.role === globalRoles.LIBRARY_MANAGER
            ? recordingSelectedRowKeys
            : [recordingId],
      });
      notify("success", "Recording deleted successfully");
      fetchAudioFiles();
      setIsRecordingDeleteModalOpen(false);
      setRecordingId(null);
      setRecordingSelectedRowKeys([]);
    } catch (err) {
      notify("error", "Failed to delete recording");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await physicianService.delete(selectedId);
      fetchPhysicians();
      setIsDeleteModalOpen(false);
      notify("success", "Physician Delete Successfully.");
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleDeletePatient = async () => {
    try {
      setLoading(true);
      const res = await patientService.delete(patientSelectedId);
      fetchPatients();
      setIsDeleteModalOpen(false);
      notify("success", "Patient Delete Successfully.");
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handlePersonalize = (video) => {
    setCurrentVideoForPersonalize(video);
    setSelectedVideoForSchedule(video);
    setIsScheduleModalOpen(true);
    setPatientEditable(true);
  };

  const handleAssignVideoToPatient = async () => {
    if (!currentVideoForPersonalize) {
      notify("error", "No video selected for personalization");
      return;
    }

    if (!selectedPatients || selectedPatients.length === 0) {
      notify("error", "Please select at least one patient");
      return;
    }

    setIsLoading(true);

    try {
      await videoService.assignVideoToPatient({
        patientIds: selectedPatients,
        videoUrl: currentVideoForPersonalize,
      });

      notify("success", "Video Assigned to Patient.");

      setSelectedPatients([]);
      setCurrentVideoForPersonalize(null);
      setIsPersonalizeModalOpen(false);
    } catch (error) {
      console.error("Error assigning video:", error);
      notify("error", error.message || "Failed to assign video to patients");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      fetchPhysicians(value, true);
    }, 500),
    []
  );

  const handleSchedulerSearch = useCallback(
    debounce((value) => {
      fetchAllAssistants(value, true);
    }, 500),
    []
  );

  // Update search/filter handlers to reset infinite scroll
  const handleVideoSearch = useCallback(
    debounce((value) => {
      setMyVideosCurrentPage(1);
      setAllVideos([]);
      getAllVideos(1, value, false);
    }, 500),
    []
  );

  const handlePatientSearch = useCallback(
    debounce((value) => {
      fetchPatients(value, true);
    }, 500),
    []
  );

  const handleScriptSearch = useCallback(
    debounce((value) => {
      fetchScript(value, true);
    }, 500),
    []
  );

  const handleRecordingSearch = useCallback(
    debounce((value) => {
      fetchAudioFiles(value);
    }, 500),
    []
  );

  const handleChangeTable = (a, b, c) => {
    const sortColumn = c?.column?.dataIndex;
    const sortOrder = c?.order;

    if (sortColumn && sortOrder) {
      const normalizedOrder = sortOrder === "ascend" ? "asc" : "desc";
      if (selectedTab === "My Scheduler") {
        setSchedulerColumn(`${sortColumn}:${normalizedOrder}`);
      } else if (selectedTab === "Script") {
        setScriptSortColumn(`${sortColumn}:${normalizedOrder}`);
      } else {
        setSortingColumn(`${sortColumn}:${normalizedOrder}`);
      }
    } else {
      setSortingColumn("");
      setSchedulerColumn("");
      setScriptSortColumn("");
    }
  };

  const fetchAllPhysician = async () => {
    try {
      const res = await physicianService.getAll(0,1,"","","");
      setAllPhysicians(res?.data?.results);
    } catch (error) {}
  };

  const PersonalizeModal = () => (
    <ModelWrapper
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            Assign Video
          </h3>
        </div>
      }
      footer={null}
      show={isPersonalizeModalOpen}
      setShow={setIsPersonalizeModalOpen}
      width={600}
      keyClose={false}
      className="custom-detail-modal"
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <div
            className="font-medium mb-10"
            style={{ color: "var(--primary-text-color)" }}
          >
            Select Patients
          </div>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select patients"
            value={selectedPatients}
            onChange={setSelectedPatients}
            disabled={isLoading}
            maxTagCount="responsive"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
          >
            {patients?.map((patient) => (
              <Option key={patient.id} value={patient.id}>
                {patient.name} - {patient.email}
              </Option>
            ))}
          </Select>
        </Col>

        <Col span={24} className="d-flex justify-end gap-12 mt-5">
          <CustomSecondaryButton
            onClick={() => {
              setIsPersonalizeModalOpen(false);
              setCurrentVideoForPersonalize(null);
              setSelectedPatients([]);
            }}
            disabled={isLoading}
          >
            Cancel
          </CustomSecondaryButton>
          <CustomButton
            onClick={handleAssignVideoToPatient}
            loading={isLoading}
            disabled={!selectedPatients.length || !currentVideoForPersonalize}
          >
            Assign
          </CustomButton>
        </Col>
      </Row>
    </ModelWrapper>
  );

  const handlePaginationChange = (page) => {
    setPagination((prev) => ({ ...prev, current: page }));
  };

  const handleSchedulerPagination = (page) => {
    setSchedulerPagination((prev) => ({ ...prev, current: page }));
  };

  const checkSelectedUsers2FAStatus = useCallback(() => {
    const selectedIds =
      selectedPhysicianIds.length > 0
        ? selectedPhysicianIds
        : selectedAssistantIds;
    if (selectedIds.length === 0) return false;

    const users = selectedPhysicianIds.length > 0 ? physicians : allAssistants;
    // Return true only if ALL selected users have 2FA disabled
    return users
      .filter((user) => selectedIds.includes(user.id || user._id))
      .every((user) => user.is2FaDisable === true);
  }, [selectedPhysicianIds, selectedAssistantIds, physicians, allAssistants]);

  const handleAction = async (actionType) => {
    const selectedIds =
      selectedPhysicianIds.length > 0
        ? selectedPhysicianIds
        : selectedAssistantIds;
    if (selectedIds.length === 0) return;

    try {
      switch (actionType) {
        case "toggleMfa":
          await authService.disableMfaUser({
            userIds: selectedIds,
            is2FaDisable: !isMfaEnabled,
          });
          notify(
            "success",
            isMfaEnabled
              ? "2FA enabled successfully"
              : "2FA disabled successfully"
          );
          if (selectedPhysicianIds.length > 0) {
            fetchPhysicians();
          } else {
            fetchAllAssistants();
          }
          break;
        case "resendInvite":
          await authService.resendInviteEmail({ userIds: selectedIds });
          notify("success", "Invite emails sent successfully");
          break;
        case "resetPassword":
          await authService.resetPasswordUsers({ userIds: selectedIds });
          notify("success", "Password reset emails sent successfully");
          break;
      }
      setSelectedPhysicianIds([]);
      setSelectedAssistantIds([]);
    } catch (error) {
      notify("error", "Failed to perform action");
    }
  };

  const actionMenu = (
    <StyledMenu>
      <Menu.Item key="mfa">
        <div className="menu-item-content">
          <LockOutlined className="menu-item-icon" />
          <span className="menu-item-text">2FA Disable</span>
          <Switch
            size="small"
            checked={isMfaEnabled}
            onChange={(checked) => {
              setIsMfaEnabled(checked);
              handleAction("toggleMfa");
            }}
          />
        </div>
      </Menu.Item>
      <Menu.Item
        key="resendInvite"
        onClick={() => handleAction("resendInvite")}
      >
        <div className="menu-item-content">
          <MailOutlined className="menu-item-icon" />
          <span className="menu-item-text">Resend Invite</span>
        </div>
      </Menu.Item>
      <Menu.Item
        key="resetPassword"
        onClick={() => handleAction("resetPassword")}
      >
        <div className="menu-item-content">
          <KeyOutlined className="menu-item-icon" />
          <span className="menu-item-text">Reset Password</span>
        </div>
      </Menu.Item>
    </StyledMenu>
  );

  const getAllVideoSpecialty = async () => {
    try {
      const res = await videoService.getVideoSpeciality();
      // console.log("res:", res?.data);

      setVideoSpecialtyList(res?.data?.videos);
    } catch (error) {}
  };

  const expandedRowRender = (record) => {
    const filteredEmails = scheduledMails.filter(
      (mail) =>
        mail?.patientId === record.id &&
        mail?.metadata?.videoName?.toLowerCase().includes(search.toLowerCase())
    );

    return (
      <div style={{ margin: 0, padding: "0 24px" }}>
        <Row
          className="d-flex"
          style={{ justifyContent: "space-between", marginBottom: 8 }}
        >
          <Typography.Title
            level={5}
            style={{ color: "var(--primary-text-color)" }}
          >
            Scheduled Videos
          </Typography.Title>
          <CustomExpandSearchContainer style={{ marginRight: "20px" }}>
            <FiSearch
              style={{ position: "absolute", zIndex: 1 }}
              className="icon ml-5"
            />
            <Input
              placeholder="Search here..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </CustomExpandSearchContainer>
        </Row>
        <ExpandedTableWrapper
          style={{
            height: "fit-content",
            maxHeight: "200px",
            overflow: "auto",
          }}
        >
          <StyledTable
            columns={expandedColumns}
            dataSource={filteredEmails}
            rowKey="id"
            loading={loading}
            pagination={false}
          />
        </ExpandedTableWrapper>
      </div>
    );
  };

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([...expandedRowKeys, record.key]);
    } else {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key !== record.key));
    }
  };

  const handleVideoPreview = (record) => {
    setSelectedVideoForPreview({
      videoUrl: record?.metadata?.videoUrl,
      title: record?.metadata?.videoName,
    });
    setIsVideoPreviewModalVisible(true);
  };

  const recordingRowSelection = {
    recordingSelectedRowKeys,
    onChange: (keys) => setRecordingSelectedRowKeys(keys),
  };

  useEffect(() => {
    setIsMfaEnabled(checkSelectedUsers2FAStatus());
  }, [selectedPhysicianIds, selectedAssistantIds, checkSelectedUsers2FAStatus]);

  useEffect(() => {
    getAllVideos();
    getMyProfile();
    getScheduledMailList();
    if (isPhysician || isOwner || user?.role === globalRoles.SUPERADMIN) {
      fetchAllAssistants();
    }
    if ((!isPhysician && !isAssistant) || isOwner) {
      fetchAllPhysician();
    }
  }, [videoPagination, videoFilterTab, videoTypeFilter, videoTypeSorting]);

  useEffect(() => {
    if (selectedTab === "Voice Recording") {
      // getAllScripts();
      // For SuperAdmin, fetch all recordings regardless of script selection
      // if (isSuperAdmin || user?.role === globalRoles.LIBRARY_MANAGER) {
        fetchAudioFiles();
      // }
    }
  }, [selectedTab, recordingStatusFilter, recordingPagination]);

  useEffect(() => {
    if ((!isPhysician && !isAssistant) || isOwner) {
      fetchPhysicians();
    }
   
    // if (selectedScriptId) {
    //   fetchAudioFiles();
    // }
  }, [isPhysician, pagination, selectedScriptId, sortingColumn, filterTab]);

  useEffect(() => {
    if (
      isPhysician ||
      isAssistant ||
      user?.role === globalRoles.SUPERADMIN ||
      isOwner
    ) {
      if(selectedTab === "Patients"){
        fetchPatients();
      }
    }
  }, [selectedTab, pagination]);
  
  useEffect(() => {
    if (isPhysician || isOwner) {
      if(selectedTab === "Script"){
      fetchScript();
      }
    }
  }, [pagination, scriptFilterTab, scriptSortColumn]);

  useEffect(() => {
    if (physicianId) {
      getPhysicianById();
    }
  }, [physicianId]);

  useEffect(() => {
    if (scriptIdForViewDetail) {
      fetchScriptById();
    }
  }, [scriptIdForViewDetail]);

  useEffect(() => {
    if (allPhysicians?.length > 0 && specialtyList === null) {
      const tags = new Set();
      allPhysicians?.filter((item) => {
        if (typeof item?.specialty === "string") {
          tags.add(item?.specialty);
        }
      });
      setSpecialtyList([...tags]);
    }
  }, [allPhysicians, physicians]);

  useEffect(() => {
    getAllVideoSpecialty();
  }, []);

  useEffect(() => {
    if (recordingData && recordingData.length > 0) {
      let filtered = [...recordingData];

      // Filter by search text
      if (recordingSearchText) {
        filtered = filtered.filter((recording) =>
          recording.name
            .toLowerCase()
            .includes(recordingSearchText.toLowerCase())
        );
      }

      // Filter by status
      if (recordingStatusFilter) {
        filtered = filtered.filter(
          (recording) => recording.status === recordingStatusFilter
        );
      }

      setFilteredRecordingData(filtered);
    } else {
      setFilteredRecordingData([]);
    }
  }, [recordingData, recordingSearchText, recordingStatusFilter]);

  // useEffect(() => {
  //   if (scripts?.length) {
  //     setSelectedScriptId(scripts[0]?.id);
  //     setSelectedScript(scripts[0]);
  //     setSelectedScriptDetails(scripts[0]);
  //   }
  // }, [scripts]);

  useEffect(() => {
    if (selectedTab === "My Videos") {
      setMyVideosCurrentPage(1);
      setAllVideos([]);
      getAllVideos(1, videoSearchText, false);
    }
  }, [videoFilterTab, videoTypeFilter, videoTypeSorting, selectedTab, videoSortOrderByTitle]);

  useEffect(() => {
    if (isPhysician || isOwner || user?.role === globalRoles.SUPERADMIN) {
      if(selectedTab === "My Scheduler"){
        fetchAllAssistants();
      }
    }
  }, [schedulerColumn, schedulerPagination]);

  const handleMyVideosLoadMore = () => {
    const nextPage = myVideosCurrentPage + 1;
    getAllVideos(nextPage, videoSearchText, true);
  };

  const hasData = physicians.length > 0;
  const scroll = hasData.length ? { y: `calc(100vh - 320px)`, x: true } : null;

  const patientScroll = patients.length;
  const assistantScroll = allAssistants.length;

  useEffect(() => {
    const urlTab = getTabFromUrl();
    if (urlTab && urlTab !== selectedTab) {
      setSelectedTab(urlTab);
    }
    if (!urlTab && selectedTab !== getInitialTab()) {
      history.replace({
        pathname: location.pathname,
        search: `?tab=${encodeURIComponent(selectedTab)}`,
      });
    }
   
  }, [location.search]);

  useEffect(() => {
    const urlTab = getTabFromUrl();
    if (selectedTab && urlTab !== selectedTab) {
      history.replace({
        pathname: location.pathname,
        search: `?tab=${encodeURIComponent(selectedTab)}`,
      });
    }
   
  }, [selectedTab]);

 

  return (
    <>
      {isCommentModalOpen && (
        <CommentModal
          isOpen={isCommentModalOpen}
          onClose={handleCommentClose}
          pendingAction={pendingAction}
          loading={loading}
          onSubmit={handleCommentSubmit}
          consentData={isConsentAccept}
          scriptData={scriptData}
        />
      )}
      {reviewedModalOpen && (
        <RevisedModal
          isOpen={reviewedModalOpen}
          onClose={() => {
            setReviewedModalOpen(false);
            setPendingAction(null);
          }}
          loading={loading}
          onSubmit={handleCommentSubmit}
          reviewedScriptData={reviewedScriptData}
          consentData={isConsentAccept}
        />
      )}
      {isPatientDetailModalOpen && (
        <PatientDetailModal
          isOpen={isPatientDetailModalOpen}
          setIsOpen={setIsPatientDetailModalOpen}
          selectedPatientDetails={selectedPatientDetails}
          scheduledMails={scheduledMails}
          isLoading={isLoading}
          setSelectedPatientForSchedule={setSelectedPatientForSchedule}
          setIsScheduleModalOpen={setIsScheduleModalOpen}
          setSelectedMailForReschedule={setSelectedMailForReschedule}
          setIsRescheduleModalOpen={setIsRescheduleModalOpen}
          cancelScheduledMail={cancelScheduledMail}
          rescheduleScheduledMail={rescheduleScheduledMail}
          setSelectedPatientDetails={setSelectedPatientDetails}
          getScheduledMailList={getScheduledMailList}
        />
      )}

      {isRescheduleModalOpen && (
        <RescheduleModal
          isOpen={isRescheduleModalOpen}
          setIsOpen={setIsRescheduleModalOpen}
          selectedMailForReschedule={selectedMailForReschedule}
          setSelectedMailForReschedule={setSelectedMailForReschedule}
          newScheduleDate={newScheduleDate}
          setNewScheduleDate={setNewScheduleDate}
          isLoading={isLoading}
          setIsRescheduleModalOpen={setIsRescheduleModalOpen}
          rescheduleScheduledMail={rescheduleScheduledMail}
        />
      )}

      {isScheduleModalOpen && (
        <ScheduleEmailModal
          isOpen={isScheduleModalOpen}
          setIsOpen={setIsScheduleModalOpen}
          selectedPatientForSchedule={selectedPatientForSchedule}
          setSelectedPatientForSchedule={setSelectedPatientForSchedule}
          selectedVideoForSchedule={selectedVideoForSchedule}
          setSelectedVideoForSchedule={setSelectedVideoForSchedule}
          scheduleDate={scheduleDate}
          setScheduleDate={setScheduleDate}
          scheduleFrequency={scheduleFrequency}
          setScheduleFrequency={setScheduleFrequency}
          repeatUntil={repeatUntil}
          setRepeatUntil={setRepeatUntil}
          enableFrequency={enableFrequency}
          setEnableFrequency={setEnableFrequency}
          customFrequencyNumber={customFrequencyNumber}
          setCustomFrequencyNumber={setCustomFrequencyNumber}
          isCustomFrequency={isCustomFrequency}
          setIsCustomFrequency={setIsCustomFrequency}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          // videos={videos}
          // patients={patients}
          schedulePatientEmail={schedulePatientEmail}
          patientEditable={patientEditable}
          setPatientEditable={setPatientEditable}
          notificationType={notificationType}
          setNotificationType={setNotificationType}
          fetchPatient={fetchPatients}
          physicianList={allPhysicians}
          userDetails={user}
          userData={isConsentAccept}
        />
      )}

      {recordingOpen && (
        <SaveRecordingModel
          fetchAudioFiles={fetchAudioFiles}
          audioUrl={audioUrl}
          setAudioUrl={setAudioUrl}
          setRecording={setRecording}
          recording={recording}
          isOpen={recordingOpen}
          setOpen={setRecordingOpen}
          scriptId={selectedScriptId}
        />
      )}

      {isOpen && (
        <AddPhysicianFormModal
          isOpen={isOpen}
          setOpen={setIsOpen}
          isEdit={isPhysicianEdit}
          setIsEdit={setIsPhysicianEdit}
          selectedPhysicianId={selectedPhysicianId}
          fetchPhysician={fetchPhysicians}
          isGroup={false}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          setOpen={setIsDeleteModalOpen}
          loading={loading}
          onConfiem={() => {
            if (selectedTab === "Dashboard") {
              handleDelete();
            } else if (selectedTab === "My Scheduler") {
              handleDeleteAssistant();
            } else if (selectedTab === "Patients") {
              handleDeletePatient();
            }
          }}
          title={
            selectedTab === "Dashboard"
              ? "Delete Physician"
              : selectedTab === "My Scheduler"
              ? "Delete Scheduler"
              : selectedTab === "Patients"
              ? "Delete Patient"
              : "Confirm Delete"
          }
        />
      )}

      {isRecordingDeleteModalOpen && (
        <DeleteConfirmationModal
          isOpen={isRecordingDeleteModalOpen}
          setOpen={setIsRecordingDeleteModalOpen}
          loading={loading}
          onConfiem={confirmDeleteRecording}
          title="Delete Recording"
          message="Are you sure you want to delete this voice recording? This action cannot be undone."
        />
      )}

      {isUploadRecordingModalOpen && (
        <UploadRecordingModal
          isOpen={isUploadRecordingModalOpen}
          setIsOpen={setIsUploadRecordingModalOpen}
          isLoading={uploadLoading}
          recordingId={selectedRecordingId}
          fetchAudioFiles={fetchAudioFiles}
        />
      )}

      {isFileSelectionModalOpen && selectedRecordingForFileSelection && (
        <FileSelectionModal
          visible={isFileSelectionModalOpen}
          setVisible={setIsFileSelectionModalOpen}
          onCancel={handleFileSelectionCancel}
          onSelect={handleFileSelectionConfirm}
          recording={selectedRecordingForFileSelection}
          action={fileSelectionAction}
          getRecordingFileFromS3={getRecordingFileFromS3}
          saveRecording={saveRecording}
        />
      )}

      {isAudioPlayerModalOpen &&
        selectedRecordingForFileSelection &&
        selectedFileType && (
          <AudioPlayerModal
            visible={isAudioPlayerModalOpen}
            setVisible={setIsAudioPlayerModalOpen}
            onCancel={handleAudioPlayerCancel}
            recording={selectedRecordingForFileSelection}
            selectedFileType={selectedFileType}
            audioUrl={recordingFileUrl}
            onDownload={saveRecording}
          />
        )}

      {isDeatilsOpen && (
        <PhysicianDetailModal
          isOpen={isDeatilsOpen}
          setOpen={setIsDeatilsOpen}
          title={
            selectedTab === "Dashboard"
              ? "Physician Details"
              : selectedTab === "My Scheduler"
              ? "Assistant Details"
              : ""
          }
          subtitle={
            selectedTab === "Dashboard"
              ? "View the details of the physician."
              : selectedTab === "My Scheduler"
              ? "View the details of the assistant."
              : ""
          }
          DataById={
            selectedTab === "Dashboard"
              ? physicianDataById
              : selectedTab === "My Scheduler"
              ? selectedAssistantData
              : null
          }
        />
      )}

      {physicianDetailModal && (
        <AssisgnedVideoModal
          isOpen={physicianDetailModal}
          setOpen={() => setPhysicianDetailModal(false)}
          physicianData={physicianData}
        />
      )}

      {isPatientCreationModalOpen && (
        <AddPatientModal
          isOpen={isPatientCreationModalOpen}
          setOpen={setIsPatientCreationModalOpen}
          isEdit={patientEdit}
          setEdit={setPatientEdit}
          patientId={patientId}
          fetchPatient={fetchPatients}
          userDetails={user}
          physicianList={allPhysicians}
        />
      )}

      {isAssistantModalOpen && (
        <AddAssistantModal
          userDetails={user}
          physicianList={allPhysicians}
          isOpen={isAssistantModalOpen}
          setOpen={setIsAssistantModalOpen}
          isEdit={isAssistantEdit}
          setEdit={setIsAssistantEdit}
          selectedAssistantId={selectedAssistantId}
          fetchAllAssistants={fetchAllAssistants}
        />
      )}

      {isPersonalizeModalOpen && (
        <PersonalizeModal
          show={isPersonalizeModalOpen}
          setshow={setIsPersonalizeModalOpen}
        />
      )}

      {scriptDetailModalOpen && (
        <ViewScriptDetails
          isOpen={scriptDetailModalOpen}
          setOpen={setScriptDetailModalOpen}
          title={"Script Details"}
          subtitle={"View the details of the script"}
          DataById={scriptDataById}
        />
      )}

      {consentModalOpen && (
        <TermAndCondition
          isOpen={consentModalOpen}
          setOpen={setConsentModalOpen}
          profileData={consentData}
        />
      )}

      {isVideoPreviewModalVisible && (
        <VideoPreviewModal
          isVisible={isVideoPreviewModalVisible}
          setIsVisible={setIsVideoPreviewModalVisible}
          onClose={() => {
            setIsVideoPreviewModalVisible(false);
            setSelectedVideoForPreview(null);
          }}
          videoUrl={selectedVideoForPreview?.videoUrl}
          title={selectedVideoForPreview?.title}
        />
      )}

      <PhysicianPageWrapper style={{ padding: "40px 60px" }}>
        <Row className="custom-header">
          <Col className="header-item">
            <CustomTitle>
              {isAssistant || isPhysician
                ? `Welcome Back, ${user?.name}`
                : user?.role === globalRoles.LIBRARY_MANAGER
                ? "Voice Library"
                : "Physicians"}
            </CustomTitle>
            {isAssistant && (
              <div className="font-16 font-medium text-secondry">
                Physician - {isConsentAccept?.parent?.name}
              </div>
            )}
            <CustomSubTitle>
              Manage your videos, record voice narrations, and send educational
              content to patients.
            </CustomSubTitle>
          </Col>
          <Col className="custom-btn">
            {!isPhysician &&
              !isAssistant &&
              (user?.role === globalRoles.SUPERADMIN || isOwner) && selectedTab === "Dashboard" && (
                <CustomButton
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  <PlusOutlined className="font-18 mt-5" />
                  Add Physician
                </CustomButton>
              )}
            {(isPhysician ||
              user?.role === globalRoles.SUPERADMIN ||
              isOwner) &&
              (selectedTab === "My Scheduler" ? (
                <CustomButton
                  onClick={() => {
                    setIsAssistantModalOpen(true);
                  }}
                >
                  <PlusOutlined className="font-18 mt-5" />
                  Add Scheduler
                </CustomButton>
              ) : (
                (selectedTab === "Patients" && (
                <CustomButton
                  onClick={() => {
                    setIsPatientCreationModalOpen(true);
                  }}
                >
                  <PlusOutlined className="font-18 mt-5" />
                  Add Patient
                </CustomButton>
                )
              )))}
            {isAssistant && (
              <CustomButton
                onClick={() => {
                  setIsPatientCreationModalOpen(true);
                }}
              >
                <PlusOutlined className="font-18 mt-5" />
                Add Patient
              </CustomButton>
            )}
          </Col>
        </Row>
        <Row className="w-100" style={{ padding: "25px 0" }}>
        {user?.role !== globalRoles.LIBRARY_MANAGER && (
          <Segmented
            className="w-100"
            style={{ backgroundColor: "#f1f5f9" }}
            options={[
              !isAssistant && !isLibraryManager && "Dashboard",
              !isAssistant && "Voice Recording",
              !isLibraryManager && "My Videos",
              !isLibraryManager && "Patients",
              user?.boardMember && "Script",
              isPhysician && "My Scheduler",
              user?.role === globalRoles.SUPERADMIN && "My Scheduler",
            ].filter(Boolean)}
            block
            value={selectedTab}
            onChange={(value) => {
              setSelectedTab(value);
              setRecordingFileUrl("");
              setRecordingFileName("");
              setPagination((prev) => ({
                ...prev,
                current: 1,
                pageSize: 25,
              }));
              setSchedulerPagination((prev) => ({
                ...prev,
                current: 1,
                pageSize: 25,
              }));
              setSearchText("");
              setSchedulerSearchText("");
              setVideoSearchText("");
              // Reset script selection when changing tabs
              if (value !== "Voice Recording") {
                setSelectedScript(null);
                setSelectedScriptDetails(null);
              }
              // Update URL (handled by useEffect, but for instant feedback)
              history.replace({
                pathname: location.pathname,
                search: `?tab=${encodeURIComponent(value)}`,
              });
            }}
          />
        )}
        </Row>

        {selectedTab === "Dashboard" && (
          <Row
            className="d-flex w-100"
            style={{ gap: "20px", justifyContent: "space-evenly" }}
          >
            <Col span={24}>
              <Row gutter={[16, 16]}>
                {/* Stats Cards */}
                <Col lg={6} md={12} sm={24} xs={24}>
                  <Card className="custom-cards">
                    <Col
                      className="d-flex mb-5"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="font-16 font-semibold text-primary">
                        Total Videos
                      </div>
                      <div>
                        <VideoCameraOutlined className="font-19 text-secondry" />
                      </div>
                    </Col>
                    <Col className="font-27 font-bold mb-5 text-primary">
                      142
                    </Col>
                    <Col className="font-15 text-secondry">
                      +6 videos added this month
                    </Col>
                  </Card>
                </Col>
                <Col lg={6} md={12} sm={24} xs={24}>
                  <Card className="custom-cards">
                    <Col
                      className="d-flex mb-5"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="font-16 font-semibold text-primary">
                        Voice Recordings
                      </div>
                      <div>
                        <AudioOutlined className="font-19 text-secondry" />
                      </div>
                    </Col>
                    <Col className="font-27 font-bold mb-5 text-primary">8</Col>
                    <Col className="font-15 text-secondry">
                      3 pending voice cloning
                    </Col>
                  </Card>
                </Col>
                <Col lg={6} md={12} sm={24} xs={24}>
                  <Card className="custom-cards">
                    <Col
                      className="d-flex mb-5"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="font-16 font-semibold text-primary">
                        Patient Views
                      </div>
                      <div>
                        <LineChartOutlined className="font-19 text-secondry" />
                      </div>
                    </Col>
                    <Col className="font-27 font-bold mb-5 text-primary">
                      573
                    </Col>
                    <Col className="font-15 text-secondry">
                      +21% from last month
                    </Col>
                  </Card>
                </Col>
                <Col lg={6} md={12} sm={24} xs={24}>
                  <Card className="custom-cards">
                    <Col
                      className="d-flex mb-5"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div className="font-16 font-semibold text-primary">
                        Average Rating
                      </div>
                      <div>
                        <StarOutlined className="font-19 text-secondry" />
                      </div>
                    </Col>
                    <Col className="font-27 font-bold mb-5 text-primary">
                      4.7/5
                    </Col>
                    <Col className="font-15 text-secondry">
                      From 218 patient ratings
                    </Col>
                  </Card>
                </Col>
              </Row>
            </Col>

            {!isPhysician && (
              <>
                <Col
                  span={24}
                  className="d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    className="d-flex  gap-12"
                    style={{ width: "100%", justifyContent: "start" }}
                  >
                    <CustomSearchContainer>
                      <FiSearch
                        style={{ position: "absolute", zIndex: 1 }}
                        className="icon ml-5"
                      />
                      <Input
                        placeholder="Search here..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          handleSearch(e.target.value);
                        }}
                      />
                    </CustomSearchContainer>
                    <Filter
                      show={show}
                      setShow={setShow}
                      data={[
                        {
                          title: "Specialty",
                          list: specialtyList,
                          filterList: filterTab,
                          setFilterList: setFilterTab,
                        },
                      ]}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {(selectedPhysicianIds.length > 0 ||
                      selectedAssistantIds.length > 0) && (
                      <Dropdown
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        overlay={actionMenu}
                        trigger={["click"]}
                        placement="bottomRight"
                        open={isDropdownVisible}
                        onOpenChange={setIsDropdownVisible}
                      >
                        <Button
                          className="text-primary"
                          icon={<MoreOutlined className="text-primary" />}
                        >
                          Actions (
                          {selectedPhysicianIds.length ||
                            selectedAssistantIds.length}
                          )
                        </Button>
                      </Dropdown>
                    )}
                  </div>
                </Col>
                <Col span={24} style={{ flex: 1, padding: "0px" }}>
                  <StyledTable
                    loading={loading}
                    columns={physicianColumns.filter((col) => !col.hidden)}
                    dataSource={physicians}
                    rowKey="id"
                    scroll={scroll}
                    pagination={{
                      current: pagination?.current,
                      pageSize: pagination?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: [25, 50, 100],
                      onShowSizeChange: (current, size) => {
                        setPagination({
                          ...pagination,
                          current,
                          pageSize: size,
                        });
                      },
                      total: count,
                      showTotal: (total, range) =>
                        `${range[0]} - ${range[1]} of ${total} physicians`,
                      showQuickJumper: false,
                      showLessItems: true,
                      onChange: handlePaginationChange,
                      itemRender: (page, type, originalElement) => {
                        if (type === "prev") {
                          return (
                            <Button
                              type="text"
                              disabled={pagination?.current === 1}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (pagination.current > 1) {
                                  setPagination((prev) => ({
                                    ...prev,
                                    current: prev.current - 1,
                                  }));
                                }
                              }}
                            >
                              Previous
                            </Button>
                          );
                        }
                        if (type === "next") {
                          const maxPage = Math.ceil(
                            count / pagination.pageSize
                          );
                          return (
                            <Button
                              type="text"
                              disabled={pagination.current === maxPage}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (pagination.current < maxPage) {
                                  setPagination((prev) => ({
                                    ...prev,
                                    current: prev.current + 1,
                                  }));
                                }
                              }}
                            >
                              Next
                            </Button>
                          );
                        }
                        return originalElement;
                      },
                    }}
                    onChange={handleChangeTable}
                  />
                </Col>
              </>
            )}

            {/* Video Ratings Card */}
            <Card>
              <Row className="mb-24">
                <Col>
                  <div className="font-23 font-semibold text-primary">
                    Video Ratings Overview
                  </div>
                  <div className="font-15 text-secondry">
                    Patient feedback on your educational content
                  </div>
                </Col>
              </Row>
              <Row className="gap-12">
                {[...Array(5)].map((_, i) => (
                  <Col
                    key={i}
                    className=" w-100 d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="d-flex font-16 gap-12">
                      <div className="d-flex" style={{ gap: "5px" }}>
                        <StarFilled />
                        <StarFilled />
                        <StarFilled />
                        <StarFilled />
                        <StarFilled />
                      </div>
                      <div>
                        <span className="font-medium text-primary">
                          5 stars
                        </span>
                      </div>
                    </div>
                    <div style={{ width: "430px" }}>
                      <Progress percent={78} showInfo={false} />
                    </div>
                    <div className="font-16 font-medium text-primary">78%</div>
                  </Col>
                ))}
              </Row>
            </Card>
          </Row>
        )}

        {selectedTab === "Voice Recording" && (
          <>
            {isSuperAdmin || user?.role === globalRoles.LIBRARY_MANAGER ? (
              <Row className="w-100">
                <Col span={24}>
                  <Card className="w-100">
                    <Row className="mb-24 d-flex align-items-center justify-content-between">
                      <Col span={12}>
                        <div className="font-23 font-semibold text-primary">
                          All Voice Recordings
                        </div>
                      </Col>

                      <Col span={12} className="d-flex gap-12">
                        {recordingSelectedRowKeys.length > 0 && (
                          <>
                            <Button
                              type="primary"
                              danger
                              onClick={() => {
                                handleDeleteRecording(recordingSelectedRowKeys);
                              }}
                              style={{
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                                transition: "all 0.2s ease",
                                borderRadius: "6px",
                                fontWeight: 500,
                                color: "red",
                                backgroundColor: "var(--primary-bg)",
                                border: "1px solid var(--border-color)",
                                padding: "0 16px",
                                fontSize: "14px",
                              }}
                            >
                              <span>
                                <DeleteOutlined />
                              </span>{" "}
                              <span>
                                Delete Selected (
                                {recordingSelectedRowKeys.length})
                              </span>
                            </Button>
                          </>
                        )}
                        <CustomExpandSearchContainer style={{ width: "200px" }}>
                          <FiSearch
                            style={{ position: "absolute", zIndex: 1 }}
                            className="icon ml-5"
                          />
                          <Input
                            placeholder="Search recordings..."
                            value={recordingSearchText}
                            onChange={(e) => {
                              setRecordingSearchText(e.target.value);
                              handleRecordingSearch(e.target.value);
                            }}
                          />
                        </CustomExpandSearchContainer>

                        <CustomFilterSelection>
                          <Select
                            placeholder="Filter by Status"
                            style={{
                              width: "180px",
                              borderRadius: "8px",
                            }}
                            value={recordingStatusFilter || null}
                            onChange={setRecordingStatusFilter}
                            allowClear
                          >
                            {/* <Option value="">All Status</Option> */}
                            <Option value="approved">Approved</Option>
                            <Option value="pending">Pending</Option>
                            <Option value="rejected">Rejected</Option>
                          </Select>
                        </CustomFilterSelection>
                      </Col>
                      {/* )} */}
                    </Row>

                    {/* No recordings found message */}
                    {recordingData &&
                      recordingData?.length > 0 &&
                      filteredRecordingData?.length === 0 && (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: "200px",
                            backgroundColor: "var(--secondary-bg)",
                            borderRadius: "12px",
                            marginBottom: "20px",
                          }}
                        >
                          <div className="text-center">
                            <AudioOutlined
                              style={{
                                fontSize: "48px",
                                color: "var(--secondary-text-color)",
                                marginBottom: "16px",
                              }}
                            />
                            <div className="font-18 font-semibold text-primary mb-8">
                              No recordings found
                            </div>
                            <div className="font-14 text-secondry">
                              Try adjusting your search or filter criteria
                            </div>
                          </div>
                        </div>
                      )}

                    {/* Show message when no data */}
                    {(!recordingData || recordingData?.length === 0) && (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: "200px",
                          backgroundColor: "var(--secondary-bg)",
                          borderRadius: "12px",
                          marginBottom: "20px",
                        }}
                      >
                        <div className="text-center">
                          <AudioOutlined
                            style={{
                              fontSize: "48px",
                              color: "var(--secondary-text-color)",
                              marginBottom: "16px",
                            }}
                          />
                          <div className="font-18 font-semibold text-primary mb-8">
                            No recordings available
                          </div>
                          <div className="font-14 text-secondry">
                            Voice recordings will appear here once they are
                            created
                          </div>
                        </div>
                      </div>
                    )}

                    {recordingData &&
                      recordingData?.length > 0 &&
                      (() => {
                        return (
                          <Col span={24} style={{ flex: 1, padding: "0px" }}>
                            <StyledTable
                              loading={loading}
                              columns={recordingColumns}
                              dataSource={recordingData}
                              rowSelection={recordingRowSelection}
                              rowKey="id"
                              scroll={
                                recordingData?.length?.length > 0
                                  ? { y: `calc(100vh - 320px)`, x: true }
                                  : null
                              }
                              pagination={{
                                current: recordingPagination?.current,
                                pageSize: recordingPagination?.pageSize,
                                showSizeChanger: true,
                                pageSizeOptions: [25, 50, 100],
                                onShowSizeChange: (current, size) => {
                                  setRecordingPagination((prev) => ({
                                    ...prev,
                                    current,
                                    pageSize: size,
                                  }));
                                },
                                total: recordingDataCount,
                                showTotal: (total, range) =>
                                  `${range[0]} - ${range[1]} of ${total} recording`,
                                showQuickJumper: false,
                                showLessItems: true,
                                itemRender: (page, type, originalElement) => {
                                  if (type === "prev") {
                                    return (
                                      <Button
                                        type="text"
                                        disabled={
                                          recordingPagination?.current === 1
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (
                                            recordingPagination?.current > 1
                                          ) {
                                            setRecordingPagination((prev) => ({
                                              ...prev,
                                              current: prev.current - 1,
                                            }));
                                          }
                                        }}
                                      >
                                        Previous
                                      </Button>
                                    );
                                  }
                                  if (type === "next") {
                                    const maxPage = Math.ceil(
                                      recordingDataCount /
                                        recordingPagination?.pageSize
                                    );
                                    return (
                                      <Button
                                        type="text"
                                        disabled={
                                          recordingPagination?.current ===
                                          maxPage
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (
                                            recordingPagination?.current <
                                            maxPage
                                          ) {
                                            setRecordingPagination((prev) => ({
                                              ...prev,
                                              current: prev.current + 1,
                                            }));
                                          }
                                        }}
                                      >
                                        Next
                                      </Button>
                                    );
                                  }
                                  return originalElement;
                                },
                              }}
                              // onChange={handleChangeTable}
                            />
                          </Col>
                        );
                      })()}
                  </Card>
                </Col>
              </Row>
            ) : (
              <Row
                className="d-flex"
                gutter={[24, 0]}
                style={{ alignItems: "flex-start" }}
              >
                <Col span={8}>
                  <Card className="w-100">
                    <Col className="mb-24">
                      <div className="font-23 font-semibold text-primary">
                        My Voice Recordings  
                      </div>
                      <div className="font-15 text-secondry">
                        View and manage your saved voice recordings.
                      </div>
                    </Col>

                    {/* Search and Filter Section */}
                    {/* {recordingData && recordingData?.length > 0 && ( */}
                      <div
                        className="d-flex justify-content-between align-items-center mb-20"
                        style={{ gap: "16px", marginBottom: "20px" }}
                      >
                        <CustomExpandSearchContainer
                          style={{ flex: 1, maxWidth: "400px" }}
                        >
                          <FiSearch
                            style={{ position: "absolute", zIndex: 1 }}
                            className="icon ml-5"
                          />
                          <Input
                            placeholder="Search recordings..."
                            value={recordingSearchText}
                            onChange={(e) => {
                              setRecordingSearchText(e.target.value);
                              handleRecordingSearch(e.target.value);
                            }}
                          />
                        </CustomExpandSearchContainer>

                        <CustomFilterSelection>
                          <Select
                            placeholder="Filter by Status"
                            style={{
                              minWidth: "180px",
                              borderRadius: "8px",
                            }}
                            value={recordingStatusFilter || null}
                            onChange={setRecordingStatusFilter}
                            allowClear
                          >
                            {/* <Option value="">All Status</Option> */}
                            <Option value="draft">Draft</Option>
                            <Option value="approved">Approved</Option>
                            <Option value="pending">Pending</Option>
                            <Option value="rejected">Rejected</Option>
                          </Select>
                        </CustomFilterSelection>
                      </div>
                    {/* )} */}

                    {/* Skeleton Loader for My Voice Recordings */}
                    {loading ? (
                      <div style={{ padding: "24px 0" }}>
                        <Skeleton active paragraph={{ rows: 4 }} />
                        <Skeleton active paragraph={{ rows: 4 }} />
                        <Skeleton active paragraph={{ rows: 4 }} />
                      </div>
                    ) : (
                      <>
                        {/* No recordings found message */}
                        {(
                          recordingData?.length === 0 &&
                          filteredRecordingData?.length === 0) && (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                height: "200px",
                                backgroundColor: "var(--secondary-bg)",
                                borderRadius: "12px",
                                marginBottom: "20px",
                              }}
                            >
                              <div className="text-center">
                                <AudioOutlined
                                  style={{
                                    fontSize: "48px",
                                    color: "var(--secondary-text-color)",
                                    marginBottom: "16px",
                                  }}
                                />
                                <div className="font-18 font-semibold text-primary mb-8">
                                  No recordings found
                                </div>
                                <div className="font-14 text-secondry">
                                  Start recording your voice to see your recordings here
                                </div>
                              </div>
                            </div>
                          )}
                        <div style={{maxHeight: "595px", overflow: "auto scroll"}}>  
                          {filteredRecordingData?.map((item, i) => (
                           <Card
                            key={i}
                            style={{
                              borderRadius: "12px",
                              border: "1px solid var(--border-color)",
                              background: "var(--primary-bg)",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                              transition: "all 0.3s ease",
                              marginBottom: "10px",
                            }}
                            bodyStyle={{ padding: "24px" }}
                            hoverable
                          >
                            {/* Top Row - Status and Action Buttons */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "16px",
                              }}
                            >
                              {/* Left Side - Status Tag */}
                              <div>
                                <Tag
                                  color={
                                    item?.status === "approved"
                                      ? "success"
                                      : item?.status === "draft"
                                      ? "warning"
                                      : "processing"
                                  }
                                  style={{
                                    borderRadius: "8px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    padding: "4px 10px",
                                    border: "none",
                                  }}
                                >
                                  {capitalizeFirstLetter(item?.status)}
                                </Tag>
                              </div>

                              {/* Action Buttons */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "12px",
                                  flexShrink: 0,
                                }}
                              >
                                <div
                                  className={`action-buttons-container-${i}`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    position: "relative",
                                    transition:
                                      "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                  }}
                                >
                                  {/* Send For Approval Button */}
                                  {item?.status === "draft" && (
                                    <Button
                                      type="primary"
                                      size="medium"
                                      className={`approval-btn approval-btn-${i}`}
                                      onClick={() => assignRecording(item?.id)}
                                      style={{
                                        backgroundColor: "var(--secondary-color)",
                                        borderColor: "var(--border-color)",
                                        borderRadius: "8px",
                                        height: "33px",
                                        width: "33px",
                                        minWidth: "33px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition:
                                          "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                        color: "var(--primary-text-color)",
                                        overflow: "hidden",
                                        padding: "0",
                                        position: "relative",
                                        whiteSpace: "nowrap",
                                        order: 3,
                                      }}
                                      icon={
                                        <TbSend
                                          className={`approval-icon-${i}`}
                                          style={{
                                            fontSize: "16px",
                                            color: "#893EF4",
                                            transition:
                                              "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                          }}
                                        />
                                      }
                                    >
                                      <span
                                        className={`approval-text-${i}`}
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          opacity: 0,
                                          width: 0,
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          transition:
                                            "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                          color: "var(--primary-text-color)",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        Send For Approval
                                      </span>
                                    </Button>
                                  )}

                                  <Tooltip title={"Download Recording"}>
                                    <Button
                                      type="default"
                                      size="large"
                                      className={`action-btn play-btn-${i}`}
                                      onClick={() => {
                                        saveRecording(item?.recording);
                                      }}
                                      style={{
                                        width: "33px",
                                        height: "33px",
                                        border: "1px solid var(--border-color)",
                                        backgroundColor: "var(--primary-bg)",
                                        color: "var(--secondary-text-color)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition:
                                          "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                        transform: "translateX(0)",
                                        opacity: 1,
                                        order: 1,
                                        borderRadius: "10px",
                                        padding: 0,
                                        lineHeight: 0,
                                      }}
                                      icon={
                                        <DownloadOutlined
                                          style={{
                                            fontSize: "16px",
                                            marginLeft: "4px",
                                          }}
                                        />
                                      }
                                    />
                                  </Tooltip>

                                  {/* Play Button */}
                                  <Tooltip
                                    title={
                                      recordingFileUrl &&
                                      recordingFileName === item?.recording
                                        ? "Playing..."
                                        : "Play Recording"
                                    }
                                  >
                                    <Button
                                      type="default"
                                      size="large"
                                      className={`action-btn play-btn-${i}`}
                                      onClick={() =>
                                        getRecordingFileFromS3(item?.recording)
                                      }
                                      style={{
                                        width: "33px",
                                        height: "33px",
                                        border:
                                          recordingFileUrl &&
                                          recordingFileName === item?.recording
                                            ? "2px solid #8A3EF4"
                                            : "1px solid var(--border-color)",
                                        backgroundColor:
                                          recordingFileUrl &&
                                          recordingFileName === item?.recording
                                            ? "#f0f2ff"
                                            : "var(--primary-bg)",
                                        color:
                                          recordingFileUrl &&
                                          recordingFileName === item?.recording
                                            ? "#8A3EF4"
                                            : "var(--secondary-text-color)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition:
                                          "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                        transform: "translateX(0)",
                                        opacity: 1,
                                        order: 1,
                                        borderRadius: "10px",
                                        padding: 0,
                                        lineHeight: 0,
                                      }}
                                      icon={
                                        recordingFileUrl &&
                                        recordingFileName === item?.recording ? (
                                          <AudioOutlined
                                            style={{
                                              fontSize: "16px",
                                              marginLeft: "4px",
                                            }}
                                          />
                                        ) : (
                                          <PlayCircleOutlined
                                            style={{
                                              fontSize: "16px",
                                              marginLeft: "4px",
                                            }}
                                          />
                                        )
                                      }
                                    />
                                  </Tooltip>

                                  {/* Delete Button */}
                                  {item?.status === "draft" && (
                                    <Tooltip title="Delete Recording">
                                      <Button
                                        type="default"
                                        size="large"
                                        className={`action-btn delete-btn-${i}`}
                                        onClick={() => {
                                          handleDeleteRecording(item?.id);
                                        }}
                                        style={{
                                          width: "33px",
                                          height: "33px",
                                          border: "1px solid #ff4d4f",
                                          backgroundColor: "var(--primary-bg)",
                                          color: "#ff4d4f",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          transition:
                                            "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                          transform: "translateX(0)",
                                          opacity: 1,
                                          order: 2,
                                          borderRadius: "10px",
                                          padding: 0,
                                          lineHeight: 0,
                                        }}
                                        icon={
                                          <DeleteOutlined
                                            style={{
                                              fontSize: "16px",
                                              marginLeft: "4px",
                                            }}
                                          />
                                        }
                                      />
                                    </Tooltip>
                                  )}

                                  <style>{`
                        .approval-btn-${i}:hover ~ .play-btn-${i},
                        .approval-btn-${i}:hover ~ .delete-btn-${i} {
                          transform: translateX(60px) !important;
                          opacity: 0 !important;
                          pointer-events: none !important;
                        }
                        
                        .approval-btn-${i}:hover {
                          width: 160px !important;
                          padding: 0 8px 0 12px !important;
                          justify-content: flex-start !important;
                        }
                        
                        .approval-btn-${i}:hover .approval-text-${i} {
                          opacity: 1 !important;
                          width: auto !important;
                          margin-left: 8px !important;
                        }
                        
                        .approval-btn-${i}:hover .approval-icon-${i} {
                          margin-right: 0px !important;
                        }

                        /* Approve Button Hover Animation */
                        .approve-btn:hover {
                          min-width: 80px !important;
                          background-color: rgba(70, 182, 72, 0.1) !important;
                          box-shadow: 0 4px 12px rgba(70, 182, 72, 0.2) !important;
                          transform: translateY(-2px) !important;
                        }
                        
                        .approve-btn:hover .approve-icon {
                          transform: scale(1.1) !important;
                        }
                        
                        .approve-btn:hover .approve-text {
                          opacity: 1 !important;
                          transform: translateX(-50%) translateY(0) !important;
                        }

                        /* Reject Button Hover Animation */
                        .reject-btn:hover {
                          min-width: 80px !important;
                          background-color: rgba(233, 29, 38, 0.1) !important;
                          box-shadow: 0 4px 12px rgba(233, 29, 38, 0.2) !important;
                          transform: translateY(-2px) !important;
                        }
                        
                        .reject-btn:hover .reject-icon {
                          transform: scale(1.1) !important;
                        }
                        
                        .reject-btn:hover .reject-text {
                          opacity: 1 !important;
                          transform: translateX(-50%) translateY(0) !important;
                        }
                      `}</style>
                                </div>
                              </div>
                            </div>

                            {/* Bottom Row - Audio Icon and Title */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "16px",
                              }}
                            >
                              {/* Audio Icon */}
                              <div
                                style={{
                                  backgroundColor: "var(--secondary-bg)",
                                  borderRadius: "12px",
                                  padding: "14px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "56px",
                                  height: "56px",
                                  flexShrink: 0,
                                }}
                              >
                                <AudioOutlined
                                  style={{
                                    fontSize: "24px",
                                    color: "#8A3EF4",
                                  }}
                                />
                              </div>

                              {/* Recording Title */}
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <h4
                                  style={{
                                    margin: 0,
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "var(--primary-text-color)",
                                    lineHeight: "1.4",
                                  }}
                                >
                                  {capitalizeFirstLetter(item?.name)}
                                </h4>
                                <div
                                  className="d-flex align-items-center justify-start"
                                  style={{ gap: "8px", marginTop: "4px" }}
                                >
                                  <CalendarOutlined
                                    style={{ fontSize: "12px", color: "#999" }}
                                  />
                                  <span className="font-13 text-secondry">
                                    {moment(item?.createdAt).format("DD MMM YYYY")}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Audio Player - Show when playing */}
                            {recordingFileUrl &&
                              recordingFileName === item?.recording && (
                                <div
                                  style={{
                                    marginTop: "20px",
                                    paddingTop: "10px",
                                    borderTop: "1px solid var(--border-color)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                  }}
                                >
                                  <audio
                                    controls
                                    autoPlay
                                    src={recordingFileUrl}
                                    style={{
                                      flex: 1,
                                      height: "40px",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              )}
                           </Card>
                          ))}
                        </div>
                      </>
                    )}
                  </Card>
                </Col>

                <Col span={16}>
                  {/* {selectedScript ? ( */}
                    <div>
                      <Card className="custom-rating-card mb-24">
                        <Col className="mb-24">
                          <div className="font-23 font-semibold text-primary">
                            Voice Recording Studio
                          </div>
                          <div className="font-15 text-secondry">
                            Record your voice by reading the script below. Your
                            voice can be cloned and mapped to videos in the
                            library.
                          </div>
                        </Col>

                        <Card
                          className="mb-24"
                          style={{ backgroundColor: "#f1f5f9" }}
                          type="inner"
                        >
                          <Scrollbar style={{ height: 300 }}>
                            <h3 className="font-18 font-semibold text-primary mb-12">
                              Script to Read: Thank you for lending your voice
                              to Meducate.
                            </h3>
                            <div
                              className="font-16 font-regular"
                              style={{ lineHeight: "1.8" }}
                            >
                              <div className="mb-4">
                                Our mission is to help patients feel informed,
                                reassured, and prepared—before and after medical
                                visits or procedures. The videos we create use
                                simple, clear language to explain health topics,
                                and your voice gives them warmth, clarity, and
                                credibility.
                              </div>

                              <div className="mb-4">
                                We cover a range of everyday topics, including
                                common conditions like high blood pressure, type
                                2 diabetes, high cholesterol, and acid reflux.
                                We also produce videos about routine procedures,
                                such as colonoscopies, heart ultrasounds, upper
                                endoscopies, and CT scans.
                              </div>

                              <div className="mb-4">
                                As a physician, your voice brings comfort and
                                trust to patients who may be anxious or unsure.
                                Whether we're helping someone understand how to
                                manage asthma, what to expect after gallbladder
                                surgery, or when to call after a child's
                                tonsillectomy—your words make all the
                                difference.
                              </div>

                              <div className="mb-24">
                                <div className="font-18 font-semibold mb-16">
                                  Here are a few example lines you may find in
                                  Meducate videos:
                                </div>
                                <ul
                                  style={{
                                    paddingLeft: "20px",
                                    listStyleType: "disc",
                                  }}
                                >
                                  <li className="mb-12">
                                    "Patients with heart failure may feel short
                                    of breath, tired, or notice swelling in
                                    their feet and ankles. It's important to
                                    weigh yourself daily, limit salt, and stay
                                    in touch with your heart doctor."
                                  </li>
                                  <li className="mb-12">
                                    "After your colonoscopy, you might feel some
                                    bloating or mild cramping. This is normal
                                    and should go away within a few hours."
                                  </li>
                                  <li className="mb-12">
                                    "For patients with acid reflux, avoiding
                                    late-night meals, spicy foods, and alcohol
                                    can often help reduce symptoms."
                                  </li>
                                </ul>
                              </div>

                              <div className="font-17 font-medium">
                                Thank you again for being part of this important
                                work. Your voice helps people better understand
                                their health—and take confident steps forward.
                              </div>
                            </div>
                          </Scrollbar>
                        </Card>

                        <Card type="inner" className="mb-24">
                          <Col className="mb-10">
                            <AudioRecorder
                              audioUrl={audioUrl}
                              setAudioUrl={setAudioUrl}
                              setRecording={setRecording}
                              recording={recording}
                              getMyProfile={getMyProfile}
                              isConsentAccept={isConsentAccept?.consentAccept}
                              profileData={isConsentAccept}
                            />
                          </Col>
                        </Card>

                        {audioUrl && (
                          <Col
                            className="d-flex"
                            style={{ justifyContent: "end" }}
                          >
                            <CustomButton
                              onClick={() => {
                                setRecordingOpen(!recordingOpen);
                              }}
                            >
                              Save Recording
                            </CustomButton>
                          </Col>
                        )}
                      </Card>
                    </div>
                  {/* ) : (
                    <Card
                      className="h-100 d-flex justify-content-center align-items-center"
                      style={{ minHeight: "600px" }}
                    >
                      <Card>
                        <div className="d-flex justify-content-center align-items-center h-100">
                          <div className="text-center">
                            <AudioOutlined
                              className="font-48 mb-3 mt-2"
                              style={{ fontSize: "25px", color: "#8A3EF4" }}
                            />
                            <div className="font-20 font-semibold text-primary mb-8">
                              Select a Script to Start Recording
                            </div>
                            <div className="font-15 text-secondry">
                              Choose a script from the left panel to begin your
                              voice recording session
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Card>
                  )} */}
                </Col>
              </Row>
            )}
          </>
        )}

        {selectedTab === "My Videos" && (
          <>
            <Row className="w-100 mb-15">
              <Col span={24} className="d-flex mt-5 justify-start gap-12">
                <div
                  className="d-flex  gap-12"
                  style={{ width: "100%", justifyContent: "start" }}
                >
                  <CustomSearchContainer>
                    <FiSearch
                      style={{ position: "absolute", zIndex: 1 }}
                      className="icon ml-5"
                    />
                    <Input
                      placeholder="Search here..."
                      value={videoSearchText}
                      onChange={(e) => {
                        setVideoSearchText(e.target.value);
                        handleVideoSearch(e.target.value);
                      }}
                    />
                  </CustomSearchContainer>

                  <CustomFilterSelectionForMyVideoPage>
                <Select
                  value={videoSortOrderByTitle || undefined}
                  style={{ width: 160 }}
                  onChange={(value) => {
                   
                      setVideoSortOrderByTitle(value);
                    
                  }}
                  allowClear
                  options={[
                    { label: "Ascending (A → Z)", value: "ascending" },
                    { label: "Descending (Z → A)", value: "descending" },
                  ]}
                  placeholder="Sort By"
                />
                </CustomFilterSelectionForMyVideoPage>


                  <Filter
                    show={show}
                    setShow={setShow}
                    data={[
                      {
                        title: "Specialty",
                        list: videoSpecialtyList || [],
                        filterList: videoFilterTab,
                        setFilterList: setVideoFilterTab,
                      },
                      {
                        title: "Video Type",
                        list: ["master", "ai enhanced", "patient education"],
                        filterList: videoTypeFilter,
                        setFilterList: setVideoTypeFilter,
                        tagColors: {
                          master: { label: "Master", color: "purple" },
                          "ai enhanced": {
                            label: "AI Enhanced",
                            color: "orange",
                          },
                          "patient education": {
                            label: "Patient Education",
                            color: "green",
                          },
                        },
                      },
                    ]}
                  />

               
                </div>
              </Col>
            </Row>
            {allVideos?.length > 0 ? (
              <>
                <VideoContainer
                  videos={{ ...videos, results: allVideos }}
                  isPersonalize={true}
                  handlePersonalize={handlePersonalize}
                  setSelectedId={setSelectedId}
                  setIsScheduleModalOpen={setIsScheduleModalOpen}
                  isLoading={isLoading}
                />
                {myVideosHasMore && (
                  <Col
                    className="mt-25 w-100 d-flex justify-content-center"
                    style={{ padding: "20px 0" }}
                  >
                    <CustomSecondaryButton
                      onClick={handleMyVideosLoadMore}
                      loading={myVideosLoadMoreLoading}
                    >
                      Load More Videos
                    </CustomSecondaryButton>
                  </Col>
                )}
                {!myVideosHasMore && allVideos.length > 0 && (
                  <Col
                    className="mt-25 w-100 d-flex justify-content-center"
                    style={{ padding: "20px 0" }}
                  >
                    <p style={{ color: "#666", fontStyle: "italic" }}>
                      No more videos to load
                    </p>
                  </Col>
                )}
              </>
            ) : isLoading ? (
              <div
                className="mt-25 w-100 d-flex justify-content-center"
                style={{ height: "400px", alignItems: "center" }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <div className="mt-25 w-100 d-flex justify-content-center">
                No Videos
              </div>
            )}
          </>
        )}

        {selectedTab === "Patients" && (
          <>
            <Row className="w-100 mb-15">
              <Col
                span={24}
                className="d-flex mt-5 justify-start gap-12"
                // style={{ justifyContent: "space-between" }}
              >
                <div
                  className="d-flex  gap-12"
                  style={{ width: "100%", justifyContent: "start" }}
                >
                  <CustomSearchContainer>
                    <FiSearch
                      style={{ position: "absolute", zIndex: 1 }}
                      className="icon ml-5"
                    />
                    <Input
                      placeholder="Search here..."
                      value={patientSearchText}
                      onChange={(e) => {
                        setPatientSearchText(e.target.value);
                        handlePatientSearch(e.target.value);
                      }}
                    />
                  </CustomSearchContainer>
                  {/* <Filter
                  show={show}
                  setShow={setShow}
                  data={[
                    {
                      title: "Specialty",
                      list: videoSpecialtyList,
                      filterList: videoFilterTab,
                      setFilterList: setVideoFilterTab,
                    },
                  ]}
                /> */}
                </div>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center">
              {isPhysician || isAssistant || isSuperAdmin || isOwner ? (
                <Col span={24} style={{ flex: 1 }}>
                  <StyledTable
                    columns={patientColumns.filter((col) => !col.hidden)}
                    dataSource={patients}
                    rowKey="id"
                    loading={loading}
                    scroll={
                      patientScroll.length > 0
                        ? { y: `calc(100vh - 320px)`, x: true }
                        : null
                    }
                    expandable={{
                      expandedRowRender,
                      expandedRowKeys,
                      onExpand: handleExpand,
                      expandIcon: ({ expanded, onExpand, record }) => (
                        // hasScheduledMails(record?.id) && (
                        <Button
                          type="text"
                          size="small"
                          icon={
                            expanded ? (
                              <DownOutlined
                                className="ml-5"
                                style={{
                                  color: hasScheduledMails(record?.id)
                                    ? "green"
                                    : "#8c8c8c",
                                }}
                              />
                            ) : (
                              <RightOutlined
                                className="ml-5"
                                style={{
                                  color: hasScheduledMails(record?.id)
                                    ? "green"
                                    : "#8c8c8c",
                                }}
                              />
                            )
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            onExpand(record, e);
                          }}
                          style={{ border: "none", padding: 0 }}
                        />
                        // )
                      ),
                    }}
                    pagination={{
                      current: pagination?.current,
                      pageSize: pagination?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: [25, 50, 100],
                      onShowSizeChange: (current, size) => {
                        setPagination({
                          ...pagination,
                          current,
                          pageSize: size,
                        });
                      },
                      total: patientCount,
                      showTotal: (total, range) =>
                        `${range[0]} - ${range[1]} of ${total} patients`,
                      showQuickJumper: false,
                      showLessItems: true,
                      onChange: handlePaginationChange,
                      itemRender: (page, type, originalElement) => {
                        if (type === "prev") {
                          return (
                            <Button
                              type="text"
                              disabled={pagination?.current === 1}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (pagination?.current > 1) {
                                  setPagination((prev) => ({
                                    ...prev,
                                    current: prev.current - 1,
                                  }));
                                }
                              }}
                            >
                              Previous
                            </Button>
                          );
                        }
                        if (type === "next") {
                          const maxPage = Math.ceil(
                            patientCount / pagination?.pageSize
                          );
                          return (
                            <Button
                              type="text"
                              disabled={pagination?.current === maxPage}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (pagination?.current < maxPage) {
                                  setPagination((prev) => ({
                                    ...prev,
                                    current: prev.current + 1,
                                  }));
                                }
                              }}
                            >
                              Next
                            </Button>
                          );
                        }
                        return originalElement;
                      },
                    }}
                  />
                </Col>
              ) : (
                <Card
                  title={
                    <div style={{ display: "block" }}>
                      <span className="font-20 text-primary">
                        Patient Management
                      </span>
                      <p className="font-15 text-secondry">
                        Manage your patients and send them educational videos.
                      </p>
                    </div>
                  }
                  variant="borderless"
                  className="w-100"
                ></Card>
              )}
            </Row>
          </>
        )}

        {selectedTab === "Script" && (
          <>
            <Col
              span={24}
              className="d-flex mb-15"
              style={{ justifyContent: "space-between", padding: "0px 24px" }}
            >
              <div
                className="d-flex  gap-12"
                style={{ width: "100%", justifyContent: "start" }}
              >
                <CustomSearchContainer>
                  <FiSearch
                    style={{ position: "absolute", zIndex: 1 }}
                    className="icon ml-5"
                  />
                  <Input
                    placeholder="Search here..."
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      handleScriptSearch(e.target.value);
                    }}
                  />
                </CustomSearchContainer>
                <Filter
                  show={show}
                  setShow={setShow}
                  data={[
                    {
                      title: "Status",
                      list: ["pending", "approved", "rejected"],
                      filterList: scriptFilterTab,
                      setFilterList: setScriptFilterTab,
                      tagColors: {
                        pending: { color: "orange", label: "PENDING" },
                        approved: { color: "green", label: "APPROVED" },
                        rejected: { color: "red", label: "REJECTED" },
                      },
                    },
                  ]}
                />
              </div>
            </Col>
            <Col span={24} style={{ flex: 1, padding: "0px 24px" }}>
              <StyledTable
                columns={scriptColumns}
                dataSource={allScript}
                rowKey="id"
                loading={loading}
                scroll={
                  allScript?.length > 0
                    ? { y: `calc(100vh - 320px)`, x: true }
                    : null
                }
                pagination={{
                  current: pagination?.current,
                  pageSize: pagination?.pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: [25, 50, 100],
                  onShowSizeChange: (current, size) => {
                    setPagination({
                      ...pagination,
                      current,
                      pageSize: size,
                    });
                  },
                  total: count,
                  showTotal: (total, range) =>
                    `${range[0]} - ${range[1]} of ${total} scripts`,
                  showQuickJumper: false,
                  showLessItems: true,
                  itemRender: (page, type, originalElement) => {
                    if (type === "prev") {
                      return (
                        <Button
                          type="text"
                          disabled={pagination?.current === 1}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (pagination?.current > 1) {
                              setPagination((prev) => ({
                                ...prev,
                                current: prev.current - 1,
                              }));
                            }
                          }}
                        >
                          Previous
                        </Button>
                      );
                    }
                    if (type === "next") {
                      const maxPage = Math.ceil(count / pagination?.pageSize);
                      return (
                        <Button
                          type="text"
                          disabled={pagination?.current === maxPage}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (pagination?.current < maxPage) {
                              setPagination((prev) => ({
                                ...prev,
                                current: prev.current + 1,
                              }));
                            }
                          }}
                        >
                          Next
                        </Button>
                      );
                    }
                    return originalElement;
                  },
                }}
                onChange={handleChangeTable}
              />
            </Col>
          </>
        )}

        {selectedTab === "My Scheduler" && (
          <Row className="d-flex justify-content-center">
            <Col span={24} style={{ flex: 1, padding: "0px 0px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}
              >
                <div
                  className="d-flex  gap-12"
                  style={{ width: "100%", justifyContent: "start" }}
                >
                  <CustomSearchContainer>
                    <FiSearch
                      style={{ position: "absolute", zIndex: 1 }}
                      className="icon ml-5"
                    />
                    <Input
                      placeholder="Search scheduler..."
                      value={schedulerSearchText}
                      onChange={(e) => {
                        setSchedulerSearchText(e.target.value);
                        handleSchedulerSearch(e.target.value);
                      }}
                    />
                  </CustomSearchContainer>
                  {/* <Filter
                    show={show}
                    setShow={setShow}
                    data={[
                      {
                        title: "Specialty",
                        list: specialtyList,
                        filterList: filterTab,
                        setFilterList: setFilterTab,
                      },
                    ]}
                  /> */}
                </div>
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  {selectedAssistantIds.length > 0 && (
                    <Dropdown
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      overlay={actionMenu}
                      trigger={["click"]}
                      placement="bottomRight"
                      open={isDropdownVisible}
                      onOpenChange={setIsDropdownVisible}
                    >
                      <Button
                        className="text-primary"
                        icon={<MoreOutlined className="text-primary" />}
                      >
                        Actions ({selectedAssistantIds.length})
                      </Button>
                    </Dropdown>
                  )}
                </div>
              </div>
              <StyledTable
                columns={myAssistantsColumns.filter((col) => !col.hidden)}
                dataSource={allAssistants}
                rowKey="_id"
                loading={loading}
                scroll={
                  assistantScroll?.length > 0
                    ? { y: `calc(100vh - 320px)`, x: true }
                    : null
                }
                pagination={{
                  current: schedulerPagination?.current,
                  pageSize: schedulerPagination?.pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: [25, 50, 100],
                  onShowSizeChange: (current, size) => {
                    setSchedulerPagination((prev) => ({
                      ...prev,
                      current,
                      pageSize: size,
                    }));
                  },
                  total: schedulerDataCount,
                  showTotal: (total, range) =>
                    `${range[0]} - ${range[1]} of ${total} schedulers`,
                  showQuickJumper: false,
                  showLessItems: true,
                  onChange: handleSchedulerPagination,
                  itemRender: (page, type, originalElement) => {
                    if (type === "prev") {
                      return (
                        <Button
                          type="text"
                          disabled={schedulerPagination?.current === 1}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (schedulerPagination?.current > 1) {
                              setSchedulerPagination((prev) => ({
                                ...prev,
                                current: prev.current - 1,
                              }));
                            }
                          }}
                        >
                          Previous
                        </Button>
                      );
                    }
                    if (type === "next") {
                      const maxPage = Math.ceil(
                        schedulerDataCount / schedulerPagination?.pageSize
                      );
                      return (
                        <Button
                          type="text"
                          disabled={schedulerPagination?.current === maxPage}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (schedulerPagination?.current < maxPage) {
                              setSchedulerPagination((prev) => ({
                                ...prev,
                                current: prev.current + 1,
                              }));
                            }
                          }}
                        >
                          Next
                        </Button>
                      );
                    }
                    return originalElement;
                  },
                }}
                onChange={handleChangeTable}
              />
            </Col>
          </Row>
        )}
      </PhysicianPageWrapper>
    </>
  );
};

export default PhysicianPage;
